<template>

	<div class="main">

		<!-- Quote number display -->
		<quote-number v-if="showQuote" :quoteNumber="getQuoteNumber"></quote-number>
		<!-- End quote number display -->

		<!-- Reseller display -->
		<reseller v-if="showReseller" :resellerDetail="$store.state.reseller"></reseller>
		<!-- End reseller display -->

		<div class="container py-4">

			<!-- Page loader -->
	        <page-loader v-if="loading"></page-loader>

			<!-- recaptcha component -->
			<captcha-validate v-show="loadCaptcha" ref="captchaCheck" :validate="validateCaptcha" @verification="captchaHasError" ></captcha-validate>

		  	<div class="row signup" v-if="!loading">

		  		<!-- Top breadcrumb header -->
		    	<breadcrumb-header :step = "step"></breadcrumb-header>
				
		    	<div class="col-md-12">

		      		<form v-on:submit="$event.preventDefault()">

			       		<!-- Start Step -->
			        	<div v-if="step === 1">
			          		<h2 class="page-header">Choose your Service</h2>
			
							<div v-if="$v.registration.service.$error" class="alert alert-danger" :class="{error: $v.registration.service.$error}" role="alert">
							  <i class="fas fa-exclamation-triangle"></i> Please select a service to proceed.
							</div>

				          	<!-- Start Card -->
				          	<div v-for="service in serviceList" :key="service.id" class="card mb-3">
					        	<div class="row no-gutters">
					              	<div class="col-md-8">
					                	<div class="card-body">
					                  		<h5 class="card-title">
					                    		<img :src="service.image_url" class="img-fluid"/>
					                    		{{ service.name }}
					                  		</h5>
					                  		<p class="card-text with-indent">
					                    		<span class="definition">Summary: </span>
					                    		<span>{{ service.summary }}</span>
					                  		</p>
					                  		<p class="card-text with-indent">
					                    		<span class="definition">Service Fees: </span>
					                    		<span v-html="getServiceFees(service)"></span>
					                  		</p>
					                	</div><!-- End of card-body -->
					              	</div><!-- End of col-md-8 -->
					              	<div class="col-md-4 card-option-select sm-margins">
					                	<label class="option-input-label input-lg-label">
					                		<input type="radio" class="option-input input-lg rounded with-check radio" name="service" v-model="registration.service"
					                    	:value="service.id" v-on:click="setService(service.alias)"/>
					                  	Select</label>
					              	</div><!-- End of col-md-4 -->
					            </div><!-- End of row -->
					        </div>
					        <!-- End of card -->

					        <!-- Start Card -->
				          	<div class="card mb-3" v-show="this.$store.state.canUseExistingQuote">
					        	<div class="row no-gutters">
					              	<div class="col-md-8">
					                	<div class="card-body">
					                  		<h5 class="card-title">
					                    		<img src="../assets/images/quoting-icon.png" style="width: 50px;" class="img-fluid"/>
					                    		Existing Quote
					                  		</h5>
					                  		<p class="card-text with-indent">
					                    		<span class="definition">Summary: </span>
					                    		<span>I have received a quote from Switch Telecom.</span>
					                  		</p>
					                  		<p class="card-text">
					                    		<span class="definition">Service Fees: </span>As quoted
					                  		</p>
					                	</div><!-- End of card-body -->
					              	</div><!-- End of col-md-8 -->
					              	<div class="col-md-4 card-option-select with-input sm-margins">
					                	<label class="option-input-label input-lg-label">
					                		<input type="radio" class="option-input input-lg rounded with-check radio" name="service" :value="-1" v-model="registration.service" v-on:click="setService('quote')"/>
					                  	Select</label>
					                  	<br>
					                  	<div class="form-group" :class="{error: $v.registration.quote_number.$error}">
					                  		<input type="text" class="form-control" v-if="registration.service == -1" placeholder="Please enter your quote number" v-model="registration.quote_number" style="width:250px;">
					                  		<p class="help-block" v-if="$v.registration.quote_number.$error && !$v.registration.quote_number.required"><i class="fas fa-exclamation-triangle"></i> Please enter your existing quote number.</p>
					              		</div>
					              	</div><!-- End of col-md-4 -->
					            </div><!-- End of row -->
					        </div>
					        <!-- End of card -->

			          		<div class="actions d-flex justify-content-end">
			            		<button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
			          		</div>
			        	</div>
			        	<!-- End Step -->

				        <!-- Start Step -->
				        <div v-if="step === 2" class="call-tariff">
				          	<h2 class="page-header">Call Rate Packages</h2>

	                        <div v-if="$v.registration.package.$error" class="alert alert-danger" :class="{error: $v.registration.package.$error}" role="alert">
							  <i class="fas fa-exclamation-triangle"></i> Please select a package to proceed.
							</div>

							<!-- Group packages by type -->
							<div v-for="(packages, type) in packageOptions">
								<h3>{{type}}</h3>
								<!-- Start Card -->
					          	<div :value="option.id" v-for="option in packages" :key="option.id" class="card package mb-3">
						        	<div class="card-body">
							        	<div class="row no-gutters">
							              	<div class="col-md-8">
						                	
						                  		<h5 class="card-title">{{getPackageName(option)}}</h5>
						                  		<p class="card-text with-indent">
						                    		<span class="definition">Summary:</span>
						                    		<span v-html="option.summary"></span>
						                  		</p>
						              		</div><!-- End of col-md-8 -->
						              	 	<div class="col-md-4 card-option-select sm-margins">
							                	<label class="option-input-label input-lg-label">
							                		<input type="radio" class="option-input input-lg rounded with-check radio" name="service" v-model="registration.package"
							                    	:value="option.id" />
							                  	Select</label>
							              	</div>
						              		<!-- End of col-md-4 --> 
							            </div>
							            <!-- End of row -->
						            </div><!-- End of card-body -->

									<div class="card-footer pt-0">
		                                <a class="text-secondary expandable" data-toggle="collapse" :href="'#collapseExample' + option.id"
		                                role="button" aria-expanded="false" :aria-controls="'#collapseExample' + option.id"
		                                title="Click for details">View Service Details<span class="icon"></span></a>
		                                <div class="collapse mt-3" :id="'collapseExample' + option.id">
		                            		<p v-if="option.recommended_for" class="card-text">
			                                    <span class="definition">Recommended: </span>
			                                    <span>{{ option.recommended_for }}</span>
			                                </p>

		                                    <table v-if="option.call_rates.length > 0" class="table table-bordered responsive-table my-4">
		                                        <thead>
		                                            <th>Destination</th>
		                                            <th>Peak VAT incl</th>
		                                            <th>Peak VAT Excl</th>
		                                            <th>Off-Peak VAT Incl</th>
		                                            <th>Off-Peak VAT Excl</th>
		                                        </thead>
		                                        <tbody>
		                                            <tr v-for="(rates, key) in option.call_rates" :key="key">
		                                                <td v-for="(item, index) in rates" :key="index" :data-label="index | capitalize">{{ item }}</td>
		                                            </tr>
		                                        </tbody>
		                                    </table>
		                                    
		                                    <!-- Info -->
		                                    <p v-if="option.rates_quote_summary" v-html="option.rates_quote_summary"></p>
		                                    <p v-if="option.peak_summary">{{ option.peak_summary }}</p>

		                                    <!-- Service detail -->
		                                    <p v-if="option.service_detail" class="card-text">
			                                    <span class="definition">Service Detail: </span>
			                                    <span v-html="option.service_detail"></span>
			                                </p>
		                                </div> <!-- End of div.collapse -->
		                            </div> <!-- End of card-footer -->
						        </div>
						        <!-- End of card -->

					    	</div>

				          	<div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
					            <button type="button" class="btn btn-dark" @click="nextStep()"  :disabled="!isCurrentStepValid || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End Step -->

				        <!-- Start Step -->
				        <div v-if="step === 3">
				          	<h2 class="page-header">Number Selection</h2>

				         	<ul class="nav nav-tabs responsive-tabs" id="myTab" role="tablist">
				            	<li class="nav-item">
				              		<a class="nav-link" :class="{active: portingActiveTab}" id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true" @click="activeNumberSelectionTab = 'porting'">Port my number</a>
				            	</li>
				            	<li class="nav-item">
				              		<a class="nav-link" :class="{active: newNumberActiveTab}" id="profile-tab" data-toggle="tab" href="#profile" role="tab" aria-controls="profile" aria-selected="false" @click="activeNumberSelectionTab = 'new_number'">Get a new number</a>
				            	</li>
				          	</ul>
				          
				          	<div class="tab-content porting" id="myTabContent">
				            	<div class="tab-pane fade show" :class="{active: portingActiveTab, show:portingActiveTab}" id="home" role="tabpanel" aria-labelledby="home-tab">
						            <table class="table table-bordered">
						            	<thead>
						                  	<tr>
						                    	<th colspan="2">Port My Number</th>
						                  	</tr>
						                </thead>
						                <tbody>
						                  	<tr v-if="showNumberRangeOption">
						                    	<th>Selection</th>
					                    		<td>
					                    			<div class="form-group" :class="{error: $v.registration.porting.number_selection.$error }">
						                    			<!-- First -->
						                    			<label for="port-individual" class="option-input-label"><input type="radio" class="option-input with-check radio" id="port-individual" value="individual" v-model="registration.porting.number_selection"/>
			  											Individual Number</label>
						                                
						                                <!-- Second -->
						                                <label for="port-number-range" class="option-input-label"><input type="radio" class="option-input with-check radio" id="port-number-range" value="range" v-model="registration.porting.number_selection"/>
			  											Number range</label>

			  											<p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.number_selection.required"><i class="fas fa-exclamation-triangle"></i> Please select an option.</p>
					                    		    </div>
					                    		</td>
						                 	</tr>
						                  	<tr v-if="registration.porting.number_selection == 'individual' && showNumberRangeOption">
							                    <th><label>Telephone Number</label></th>
							                    <td>
							                    	<div class="form-group" :class="{error: $v.telephone.$error}">
								                      	<input
									                        type="text"
									                        class="form-control" :placeholder="individualNumberPlaceholder"
									                        v-model="telephone" v-on:blur="addIndividualNumbers" style="width: 90%; display:inline-block;"
									                      />
								                      	<button type="button" class="btn btn-success btn-sm" @click="addIndividualNumbers" style="display:inline-block;float:right;"><i class="fas fa-plus"></i></button>
								                      	<br>
								                      	<p class="help-block" v-if="$v.telephone.$error && !$v.telephone.required"><i class="fas fa-exclam ation-triangle"></i> Please enter a telephone number.</p>
								                    </div>
							                      	
							                      	<div class="separator border-top mt-3 mb-2 pt-2" v-show="registration.porting.individual_numbers.length > 0">
														<p class="font-weight-bold mb-0">Selected numbers:</p>
							                      	</div>

							                      	<div v-for="(element, key) in registration.porting.individual_numbers">
									                      <input
									                        type="text" 
									                        class="form-control my-1" placeholder="Telephone Number" v-model = "registration.porting.individual_numbers[key]"
									                         style="width: 90%; display:inline-block;"
									                      />
									                     <button type="button" class="btn btn-danger btn-sm" @click="removeIndividualNumber(key)" style="display:inline-block;float:right;"><i class="fas fa-minus-circle"></i></button>
									                </div>
							                    </td>
						                  	</tr>
							                <tr v-if="registration.porting.number_selection == 'range' && showNumberRangeOption">
							                    <th>From</th>
							                    <td>
							                    	<div class="form-group" :class="{error: $v.registration.porting.number_range_start.$error}">
								                      	<input
								                        type="text"
								                        class="form-control" placeholder="Number starting from"
								                        v-model="registration.porting.number_range_start"
								                      	/>
								                      	<p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.number_range_start.required"><i class="fas fa-exclamation-triangle"></i> Please enter the telephone number at the beginning of the range.</p>
								                    </div>
							                    </td>
							                </tr>
						                  	<tr v-if="registration.porting.number_selection == 'range' && showNumberRangeOption">
						                    	<th>To</th>
						                    	<td>
						                    		<div class="form-group" :class="{error: $v.registration.porting.number_range_end.$error}">
							                      		<input
								                        type="text"
								                        class="form-control" placeholder="Number ending at"
								                        v-model="registration.porting.number_range_end"/>
								                        <p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.number_range_end.required"><i class="fas fa-exclamation-triangle"></i> Please enter the telephone number at the end of the range.</p>
						                    		</div>
						                    	</td>
						                  	</tr>
						                  	<tr v-if="!showNumberRangeOption">
						                  		<th><label>Telephone Number</label></th>
							                    <td>
							                    	<div class="form-group" :class="{error: $v.singleTelephone.$error}">
								                      	<input
									                        type="text"
									                        class="form-control" placeholder="Enter the telephone number to port"
									                        v-model="singleTelephone" v-on:blur="addSingleTelephone"
									                      />
									                      <p class="help-block" v-if="$v.singleTelephone.$error"><i class="fas fa-exclamation-triangle"></i> Please enter the telephone number to port.</p>
							                    	</div>
							                    </td>
						                  	</tr>
						                  	<tr>
						                    	<th><label>Account Number</label></th>
						                    	<td>
						                    		<div class="form-group" :class="{error: $v.registration.porting.account_number.$error}">
							                     	 	<input
								                        type="text"
								                        class="form-control" placeholder="Account Number"
								                        v-model="registration.porting.account_number"/>
								                        <p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.account_number.required"><i class="fas fa-exclamation-triangle"></i> Please enter the account number information.</p>
								                    </div>
						                    	</td>
						                  	</tr>
						                  	<tr>
						                    	<th><label>Account Holder</label></th>
						                    	<td>
						                    		<div class="form-group" :class="{error: $v.registration.porting.account_holder.$error}">
								                      	<input
								                        type="text"
								                        class="form-control" placeholder="Account Holder"
								                        v-model="registration.porting.account_holder"
								                      	/>
								                      	<p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.account_holder.required"><i class="fas fa-exclamation-triangle"></i> Please enter the account holder information.</p>
								                    </div>
						                    	</td>
						                  	</tr>
						                  	<tr>
						                    	<th><label>Prepaid</label></th>
						                    	<td>
						                    		<div class="form-group" :class="{error: $v.registration.porting.is_prepaid.$error}">
							                    		<!-- First -->
						                    			<label for="prepaid-number" class="option-input-label"><input type="radio" class="option-input with-check radio" id="prepaid-number" :value="true" v-model="registration.porting.is_prepaid"/>
			  											Yes</label>

			  											<!-- Second -->
						                    			<label for="postpaid-number" class="option-input-label"><input type="radio" class="option-input with-check radio" id="postpaid-number" :value="false" v-model="registration.porting.is_prepaid"/>
			  											No</label>
			  											<p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.is_prepaid.required"><i class="fas fa-exclamation-triangle"></i> Please specify if the account is prepaid or postpaid.</p>
			  										</div>
						                   	 	</td>
						                  	</tr>
						                  	<tr>
						                    	<th> <label>Is there ADSL or Fibre associated with this number?</label></th>
						                    	<td>
						                    		<div class="form-group" :class="{error: $v.registration.porting.has_existing_service.$error}">
							                    		<!-- First -->
						                    			<label for="has-existing-service" class="option-input-label"><input type="radio" class="option-input with-check radio" id="has-existing-service" :value="true" v-model="registration.porting.has_existing_service"/>
			  											Yes</label>
			  											
			  											<!-- Second -->
						                    			<label for="no-existing-service" class="option-input-label"><input type="radio" class="option-input with-check radio" id="no-existing-service" :value="false" v-model="registration.porting.has_existing_service"/>
			  											No</label>
			  											<p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.has_existing_service.required"><i class="fas fa-exclamation-triangle"></i> Please specify if the number is associated with ADSL or Fibre.</p>
			  										</div>
						                   	 	</td>
						                  	</tr>
						                 	<tr v-if="registration.porting.has_existing_service">
						                    	<th><label>Retain existing service?</label></th>
						                    	<td>
						                    		<div class="form-group" :class="{error: $v.registration.porting.retain_existing.$error}">
							                    		<!-- First -->
						                    			<label for="retain-existing-service" class="option-input-label"><input type="radio" class="option-input with-check radio" id="retain-existing-service" :value="true" v-model="registration.porting.retain_existing"/>
			  											Yes</label>
			  											
			  											<!-- Second -->
						                    			<label for="do-not-retain-existing-service" class="option-input-label"><input type="radio" class="option-input with-check radio" id="do-not-retain-existing-service" :value="false" v-model="registration.porting.retain_existing"/>
			  											No</label>

			  											<p class="help-block" v-if="$v.registration.porting.$error && !$v.registration.porting.retain_existing.required"><i class="fas fa-exclamation-triangle"></i> Please specify if the existing service should remain.</p>
			  											
								                      	<small class="form-text">Yes - Existing ADSL or Fibre service should remain active and receive a new phone number</small>
								                       <small class="form-text">No - Existing ADSL or Fibre service should be cancelled after porting</small>
								                    </div>
						                    	</td>
						                  	</tr>
							                <tr>
							                    <td colspan="2">
							                    	<div class="form-group" :class="{error: $v.validation.accountPaid.$error}">
								                    	<!-- First -->
								                    	<label for="confirm-account-paid" class="option-input-label"><input type="checkbox" class="option-input with-check" id="confirm-account-paid" v-model="validation.accountPaid" />I confirm that my account with the donor service provider is fully paid.</label>
			  											<label v-show="false"><i class="fas fa-exclamation-triangle"></i> {{showAccountPaidFail}}</label>
														<p class="help-block" v-if="$v.validation.accountPaid.$error && !$v.validation.accountPaid.checked"><i class="fas fa-exclamation-triangle"></i> Please confirm that the account is fully paid.</p>
													</div>

													<div class="form-group" :class="{error: $v.validation.numberLinkedToActiveService.$error}">
														<!-- Second -->
								                        <label for="confirm-porting" class="option-input-label"><input type="checkbox" class="option-input with-check" id="confirm-porting"  v-model="validation.numberLinkedToActiveService"/>I further confirm that the number(s) I wish to port are currently associated with an active telephone service.</label>
			  											<label v-show="false"><i class="fas fa-exclamation-triangle"></i> {{showNumberLinkedToCancelled}}</label>
			  											<p class="help-block" v-if="$v.validation.numberLinkedToActiveService.$error && !$v.validation.numberLinkedToActiveService.checked"><i class="fas fa-exclamation-triangle"></i> Please confirm that the account is linked to an active telephone service.</p>
													</div>
							                    </td>
							                 </tr>
						                </tbody>
						            </table>
				            	</div>
				            	<!-- End of tab pane 1 -->
				            
				            	<div class="tab-pane fade" :class="{active: newNumberActiveTab, show:newNumberActiveTab}" id="profile" role="tabpanel" aria-labelledby="profile-tab">
				              		<table class="table table-bordered">
				                	<thead>
				                  		<tr>
				                    		<th colspan="2">Get a new number</th>
				                  		</tr>
				                		</thead>
				                		
					                  		<!-- Get a new number -->
					                  		<number v-for="(number, position) in registration.new_number"
										              :key="position" :position="position"
										              :areaCodes = "areaCodes" :number="number" :service="serviceSelection" v-on:deleteNumber="deleteNumber" :completingSection="completingNewNumber" ref="additionalNumbers" :validate="validateNewNumber" ></number>
							            <tbody>
							               	<tr v-if="serviceSelection != 'voipLineService'">
									            <td colspan="2" class="text-center">
									                <button
									                    type="button"
									                    class="btn btn-success btn-sm"
									                    @click="addNewNumber"
									                  >
									                    <i class="fas fa-plus"></i> Add Additional Number
									                </button>
									            </td>
									        </tr>
						                  	<tr>
							                    <td colspan="2">
							                    	<div class="form-group" :class="{error: $v.validation.areaConfirmation.$error && !$v.validation.areaConfirmation.checked}">
								                    	<!-- Confirm -->
						                    			<label for="confirm-area-code" class="option-input-label"><input type="checkbox" class="option-input with-check" id="confirm-area-code" v-model="validation.areaConfirmation" />I confirm that my
								                        business or postal address corresponds with the area code I have selected.</label>
								                        <p class="help-block" v-if="$v.validation.areaConfirmation.$error && !$v.validation.areaConfirmation.checked"><i class="fas fa-exclamation-triangle"></i> The business or postal address corresponds to the area I have selected.</p>
							                    	</div>
							                    </td>
						                  	</tr>
						                </tbody>
				              		</table>
				            	</div>
				            	<!-- End of tab pane 2 -->
				          	</div>

				          	<div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
					            <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading" >Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End Step -->

				        <!-- Start Step -->
				        <div v-if="step === 4 && serviceSelection == 'vpbx'">
				          	<h2 class="page-header">Hosted Switchboard Selection</h2>

				          	<table class="table table-bordered">
					            <thead>
					              	<tr>
					                	<th colspan="2">Hosted switchboard Service</th>
					              	</tr>
					            </thead>
				            	<tbody>
					              	<tr>
						                <th><label class="required">Number of extensions</label></th>
						                <td>
											<div class="form-group" :class="{error: $v.registration.switchboard.extensions.$error}">
							                	<input type="number" class="form-control" v-model="registration.switchboard.extensions" placeholder="Number of extensions" @click="$event.target.focus()" v-on:blur="validateExtensions"/>
							                	<small class="d-block mt-2"><i class="fas fa-info-circle color-info"></i> Extensions must be selected in multiples of 10.
												Non-multiples shall be rounded upwards. (E.g. 11 will be rounded to 20.)</small>

						                		<p v-if="$v.registration.switchboard.$error && !$v.registration.switchboard.extensions.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please select the number of extensions you require.</p>
						                		<p v-if="$v.registration.switchboard.$error && !$v.registration.switchboard.extensions.minValue" class="help-block"><i class="fas fa-exclamation-triangle"></i> Extensions must be selected in multiples of 10.</p>
						                	</div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label>Call Recording</label></th>
						                <td>
						                  	<select class="form-control" v-model="registration.switchboard.call_recording_option">
						                    	<option value="0" selected="">Not required</option>
						                    	<option
							                      :value="recording.id"
							                      v-for="recording in callRecordingList"
							                      :key="recording.id"
							                      >{{ recording.name }} - {{recording.service_fees_with_vat}}
						                    	</option>
						                  	</select>
						                </td>
						            </tr>
				              		<tr>
					                <th><label>Professional Voice Recordings</label></th>
						                <td>
							                <select class="form-control" v-model="registration.switchboard.voice_pro">
							                    <option value="0" selected="">Not required</option>
							                    <option
							                      :value="voicePro.id"
							                      v-for="voicePro in voiceProList"
							                      :key="voicePro.id"
							                      >{{ voicePro.name }} - {{ voicePro.summary }} - {{voicePro.service_fees_with_vat}}</option
							                    >
							                </select>
						                </td>
					              	</tr>
				            	</tbody>
				          	</table>

				          	<div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End Step -->
				    
				        <!-- Start Step -->
				        <div v-if="step === 5 && (serviceSelection == 'voipTrunkService' || serviceSelection == 'vpbx')">
				          	<h2 class="page-header">Trunk Selection</h2>

				          	<table class="table table-bordered">
					            <thead>
					              	<tr>
					                	<th colspan="2">VoIP Trunk Service</th>
					              	</tr>
					            </thead>
				            	<tbody>
						            <tr>
						               	<th><label>Number of channels</label></th>
						                <td v-if="!isUnlimitedPackage">
						                	<div class="form-group" :class="{error: $v.registration.trunk.channels.$error}">
						                		<input type="number" class="form-control" v-model="registration.trunk.channels" placeholder="Number of channels" @click="$event.target.focus()" @blur="validateChannels" />
						                		<p v-if="$v.registration.trunk.$error && !$v.registration.trunk.channels.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the number of channels your require.</p>
						                		<p v-if="$v.registration.trunk.$error && !$v.registration.trunk.channels.minValue" class="help-block"><i class="fas fa-exclamation-triangle"></i> You can choose from a minimum of 4 channels on a VoIP Trunk.</p>
						                	</div>
						                </td>
						                <td v-if="isUnlimitedPackage">
						                	<div class="form-group" :class="{error: $v.registration.trunk.channels.$error}">
						                		<select class="form-control" v-model="registration.trunk.channels">
						                			<option value="">-- Select --</option>
						                			<option :value="channel" v-for="channel in unlimitedTrunkChannels">{{channel}}</option>
						                		</select>
						                		<p v-if="$v.registration.trunk.$error && !$v.registration.trunk.channels.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please select the number of channels your require.</p>
						                		<p v-if="$v.registration.trunk.$error && !$v.registration.trunk.channels.minValue" class="help-block"><i class="fas fa-exclamation-triangle"></i> You can choose only choose between 4, 8 and 16 channels for an Unlimited Unlimited Flat Rate package.</p>
						                	</div>
						                </td>
						            </tr>
					            </tbody>
					        </table>

				          	<div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End Step -->

				        <!-- Start Step -->
				        <div v-if="step === 6 && serviceSelection != 'voipTrunkService'">
				          	<h2 class="page-header">Phone Order</h2>

				          	<!-- table for cart -->
				          	<table class="table table-bordered cart responsive-cart my-5" v-if="cart.length != ''">
					            <thead>
					              	<tr>
						                <th>Phone</th>
						                <th :colspan="limitAddToCart ? '1' : '3'">Quantity</th>
						                <th>Unit Price</th>
						                <th>Exc VAT</th>
						                <th>Inc VAT</th>
						                <th>Total Price</th>
						                <th>Action</th>
					              	</tr>
					            </thead>
					            <tbody>
					              	<tr v-for="(item, key) in cart" :key="key" class="item-row">
						              
						                <td class="single-item"><img :src="item.image_url" alt="" class="image-display rounded-circle img-fluid"> <span>{{ item.name }}</span></td>
						                <td v-if="!limitAddToCart" cart-label="Increase" class="bg-light split-cell cursor-pointer" @click.prevent="addPhoneToCart(-1, item.id)" title="Increase quantity">
						                   <span><i class="fas fa-plus"></i>
						                  </span></td>
						                <td cart-label="Quantity" class="split-cell">{{ item.quantity }}</td>
						                <td v-if="!limitAddToCart" cart-label="Decrease" class="bg-light split-cell cursor-pointer" @click.prevent="removePhoneFromCart(-1, item.id)" title="Decrease quantity"> <span><i class="fas fa-minus"></i>
						                  </span></td>
						                <td cart-label="Unit Price">{{ item.unit_price }}</td>
						                <td cart-label="Exc VAT">{{ item.price_excluding_vat }}</td>
						                <td cart-label="Inc VAT">{{ item.vat_amount }}</td>
						                <td cart-label="Total Price">{{ item.price_including_vat }}</td>
						                <td cart-label="Remove item">
							                <button
							                    class="btn btn-link text-danger"
							                    v-on:click.prevent="deletePhoneFromCart(item)" title="Remove item"
							                  >
							                    <i class="fas fa-times"></i>
							                 </button>
						                </td>
					              	</tr>
					            </tbody>
					            <tfoot>
					              	<tr>
						                <td :colspan="limitAddToCart ? '3' : '5'" class="total-label">
						                  Sub-total
						                </td>
						                <td cart-label="Exc VAT">{{this.cartTotals.total_excluding_vat}}</td>
						                <td cart-label="Inc VAT">{{this.cartTotals.total_vat_amount}}</td>
						                <td cart-label="Total Price">{{this.cartTotals.total_including_vat}}</td>
						                <td cart-label="Clear cart">
						                  <button
						                    class="btn btn-link text-danger"
						                    @click.prevent="emptyCart()" title="Clear cart"
						                  >
						                    <i class="fas fa-trash-alt"></i>
						                  </button>
						                </td>
					              	</tr>
					            </tfoot>
				          	</table>

							<!-- Bundle Options -->
							<div class="my-5" v-if="bundleOptions.length !=0">
								<p>The following devices require a compatible hardware option:</p>

								<div class="card" v-for="(option, index) in bundleOptions">
								  <div class="card-header font-weight-bold">
								    {{getPhoneName(option.hardware)}}
								  </div>
								  <ul class="list-group list-group-flush">
								    <li class="list-group-item" v-for="(choice, key) in option.options"> <img :src="choice.image_url" class="image-display rounded-circle img-fluid" alt=""> {{choice.name}} - {{choice.unit_cost_ex_vat}} <small>({{choice.unit_cost_inc_vat}} +VAT)</small> <span class="badge badge-success badge-pill cursor-pointer ml-2" @click="addPhoneToCart(-1, choice.id)">Add to cart</span></li>
								  </ul>
								</div>
								
							</div> 
							<!-- End bundle options -->

				          	<!-- Filter -->
				         	<h3>Click to filter</h3>
				          	<div class="list">
					            <button class="btn btn-outline-info m-2" :class="{active: activeFilter == 'all'}" @click.prevent="filterItems('all')">All</button>
					            <button
					              class="btn btn-outline-info m-2"
					              :class="{active: activeFilter == key}"
					              v-for="(category, key) in phoneList"
					              :key="key"
					              @click.prevent="filterItems(key)"
					            >
					              {{ key }}
					            </button>
				         	</div>

				          	<!-- Phones -->
				          	<h3 class="mt-5 mb-2">View our range of phones below</h3>
							
							<!-- Carousel view -->
							<div class="carousel-view" >
								<div class="d-flex justify-content-between">
									
									<!-- button -->
									<div class="d-flex align-items-center prev-btn">
										<button type="button" class="btn btn-dark phone-slider previous" @click.prevent="prev" href="#" ><i class="fas fa-angle-left"></i></button>
									</div>

									<!-- phones -->
									<transition-group name="carousel" tag="div" class="phone-carousel" v-if="currentPhone">
										<div class="card slide" v-for="key in [currentIndex]" :key="key" >
								            <div class="row no-gutters">
											    <div class="col-md-8">
											        <div class="card-body">
											            <h5 class="card-title">{{ currentPhone.name }}</h5>
											            <p class="card-text">
											                <span class="">Price: </span>{{ currentPhone.price }}
											            </p>
											            <p>
											            	<span class="d-block font-weight-bold">Details:</span>
											            	<span class="card-text" v-html="currentPhone.summary"></span>
														</p>
											            <a
											                class="btn btn-success text-white btn-sm"
											                v-on:click.prevent="addPhoneToCart(key)"
											                title="Select phone"
											                v-if="limitAddToCart == false || foundInBundle(currentPhone)"
											                ><i class="fas fa-plus"></i> Add to cart</a>
											        </div><!-- End of card-body -->
											    </div><!-- End of col-md-8 -->
											    <div class="col-md-4 image-holder">
											        <img :src="currentPhone.image_url | decode" class="card-img" alt="" />
											    </div><!-- End of col-md-4 -->
											</div>
											<!-- End of row -->
							         	</div> <!-- End of card -->

									</transition-group>
									
									<!-- button -->
									<div class="d-flex align-items-center next-btn">
										<button class="btn btn-dark phone-slider next" @click.prevent="next" href="#" ><i class="fas fa-angle-right"></i></button>
									</div>
								</div>
							</div>
							<!-- Carousel view -->
						
					        <div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="bundleOptions.length != 0 || isBtnLoading">{{ phoneOrderAction }} <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
					        </div>
				        </div>
				        <!-- End of Step -->

				        <!-- Start Step -->
				        <div v-if="step === 7">

				        	<h2 class="page-header">Order Confirmation</h2>

				          	<table class="table table-bordered" v-if="serviceConfirmation.services != null && serviceConfirmation.costs != null && serviceConfirmation.services.hasOwnProperty('service') ">
				            	<thead>
					              	<tr>
					                	<th colspan="2"><label>Your selection is as follows</label></th>
					              	</tr>
				           		</thead>
				            	<tbody>
					              	<tr>
						                <th><label>Solution</label></th>
						                <td v-html="serviceDetails"></td>
					              	</tr>
					              	<tr v-if="showNumbersOfDdis">
						                <th><label>Numbers (Direct Dial Numbers)</label></th>
						                <td v-html="serviceNumbers"></td>
					              	</tr>
					              	<tr v-if="serviceAddons != ''">
					              		<th><label>Additional Solutions</label></th>
					              		<td v-html="serviceAddons"></td>
					              	</tr>
					              	<tr>
						                <th><label>Tariff Plan</label></th>
						                <td>{{ serviceConfirmation.services.tarrif_plan }}</td>
					              	</tr>
					              	<tr v-if="portNumberSelection != ''">
						                <th><label>Number Selection</label></th>
						                <td v-html="portNumberSelection"></td>	
					              	</tr>
					              	<tr v-if="portDetails != ''">
						                <th><label>Port Details</label></th>
						                <td v-html="portDetails"></td>	
					              	</tr>
					              	<tr v-if="handsetDetails != ''">
						                <th><label>Hardware</label></th>
						                <td v-html="handsetDetails"></td>
					              	</tr>
					              	<tr>
						                <th colspan="2">
						                  <label class="font-weight-bold text-uppercase">Costs</label>
						                </th>
					              	</tr>
					              	<tr v-if="totalOnceOffFees && totalOnceOffFees.hasOwnProperty('hardware')">
						                <th><label>Once-off (Hardware)</label></th>
						                <td>{{totalOnceOffFees.hardware}}</td>
					              	</tr>
					              	<tr v-if="totalOnceOffFees && totalOnceOffFees.hasOwnProperty('discount')">
						                <th><label>Once-off (Discount)</label></th>
						                <td>{{totalOnceOffFees.discount}}</td>
					              	</tr>
					              	<tr v-if="totalOnceOffFees && totalOnceOffFees.hasOwnProperty('porting')">
						                <th><label>Once-off (Porting)</label></th>
						                <td>{{totalOnceOffFees.porting}}</td>
					              	</tr>
					              	<tr v-if="totalOnceOffFees && totalOnceOffFees.hasOwnProperty('voice_pro')">
						                <th><label>Once-off (Voice Pro)</label></th>
						                <td>{{totalOnceOffFees.voice_pro}}</td>
					              	</tr>
					              	<tr v-if="serviceConfirmation.costs.hasOwnProperty('once_off_fees')">
						                <th class="font-weight-bold"><label>Total Once-off</label></th>
						                <td class="font-weight-bold">{{serviceConfirmation.costs.once_off_fees}}</td>
					              	</tr>
					              	<tr>
						                <th class="font-weight-bold"><label>Monthly Service Fee</label></th>
						                <td class="font-weight-bold">{{serviceConfirmation.costs.recurring_fees}}</td>
					              	</tr>
					              	<tr v-if="showMonthlyUsage">
						                <th><label>Monthly (Usage)</label></th>
						                <td v-if="serviceConfirmation.services.tarrif_plan != 'Package 1' && serviceConfirmation.services.tarrif_plan != 'Package 2'">Package as per tariff plan</td>
						                <td v-if="serviceConfirmation.services.tarrif_plan == 'Package 1' || serviceConfirmation.services.tarrif_plan == 'Package 2'">Call charges in accordance with {{ serviceConfirmation.services.tarrif_plan }}</td>
					              	</tr>
					              	<tr>
						                <th colspan="2">
						                  <label class="font-weight-bold text-uppercase">Confirmation</label>
					                	</th>
					              	</tr>
				             	 	<tr>
				                		<td colspan="2">
				                			<!-- First -->
			                    			<label for="certain" class="option-input-label"><input type="radio" class="option-input with-check radio" id="certain" value="satisfied" v-model="confirmation"/>I am satisfied with the selection above. I fully understand the requirements. Please proceed with the order immediately.</label>
											
											<!-- Second -->
			                    			<label for="confirm" class="option-input-label"><input type="radio" class="option-input with-check radio" id="confirm" value="confirm" v-model="confirmation" />I have chosen this service to the best of my understanding. Please contact me to confirm that it is suitable for my requirements before finalising the order.</label>
											
											<!-- Third -->
				                    		<label for="undecided" class="option-input-label" v-show="this.$store.state.canBeUndecided"><input type="radio" class="option-input with-check radio" id="undecided" value="undecided" v-model="confirmation" />I am undecided, please email me a quote.</label>
					                  		
					                  		<div v-if="$v.confirmation.$error" class="alert alert-danger" :class="{error: $v.confirmation.$error}" role="alert">
												<i class="fas fa-exclamation-triangle"></i> Please confirm an action to proceed.
											</div>
				                		</td>
				              		</tr>
				            	</tbody>
				          	</table>

				          	<div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End of Step -->

				        <!-- Start Step -->
				        <div v-if="step === 8">
				        	<p v-if="serviceSelection == 'transferServices' || serviceSelection == 'quoteWithTransfer'"><i class="fas fa-info-circle"></i> Please fill in the details of the company or individual the services will be transferred to.</p>
				          	<table class="table table-bordered">
				            	<thead>
					              	<tr>
					                	<th colspan="2">Client Details</th>
					              	</tr>
				            	</thead>
				            	<tbody>
					              	<tr>
					                	<th><label class="required">Type of Client</label></th>
					                	<td>
					                		<div class="form-group" :class="{error: $v.registration.client.clientType.$error}">
							                  	<select class="form-control" v-model="registration.client.clientType">
								                    <option value="">-- Select --</option>
								                    <option value="individual">Individual</option>
								                    <option value="business">Business/Organisation</option>
							                  	</select>
							                  	<p v-if="$v.registration.client.$error && !$v.registration.client.clientType.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please select the type of client: Individual or Business.</p>
							                </div>
					                	</td>
					              	</tr>
					              	<tr v-show="registration.client.clientType != ''">
					              		<th colspan="2" class="text-center">{{registration.client.clientType | capitalize}}</th>
					              	</tr>
					              	<tr>
					                	<th><label class="required">{{clientNameLabel}}</label></th>
					                	<td>
					                		<div class="form-group" :class="{error: $v.registration.client.clientName.$error}">
						                		<input type="text" class="form-control" :placeholder="clientNameLabel" v-model="registration.client.clientName" />
		                                        <p v-if="$v.registration.client.$error && !$v.registration.client.clientName.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the client's {{clientNameLabel | lowercase}}.</p>
		                                        <p v-if="$v.registration.client.$error && !$v.registration.client.clientName.minLength" class="help-block"><i class="fas fa-exclamation-triangle"></i> The {{clientNameLabel | lowercase}} must be {{$v.registration.client.clientName.$params.minLength.min}} or more characters.</p>
		                                    </div>
					                	</td>
					              	</tr>
				            	</tbody>
				            	<tbody  v-if="registration.client.clientType == 'individual' || registration.client.clientType == ''">
					              	
					              	<tr>
					                	<th><label class="required">ID Number/Passport</label></th>
					                	<td>
											<div class="form-group" :class="{error: $v.registration.client.idNumber.$error}">
						                		<input type="text" class="form-control" placeholder="Identity Number" v-model="registration.client.idNumber" />
											 	<p v-if="$v.registration.client.$error && !$v.registration.client.idNumber.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the client's ID Number or passport.</p>
											 </div>
					                	</td>
					              	</tr>
				            	</tbody>
				            	<tbody v-if="registration.client.clientType == 'business'">
					              	<tr>
						                <th><label class="required">Registration Number</label></th>
						                <td><div class="form-group" :class="{error: $v.registration.client.registrationNumber.$error}">
						                		<input type="text" class="form-control" placeholder="Registration Number" v-model="registration.client.registrationNumber" />
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.registrationNumber.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> The company registration number is required.</p>
		                                        <p v-if="$v.registration.client.$error && !$v.registration.client.registrationNumber.isValidRegistration" class="help-block"><i class="fas fa-exclamation-triangle"></i> Invalid registration number entered. Only the slash / character is allowed, no other special character.</p>
	                                       </div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label>VAT Number</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.vatNumber.$error}">
						                		<input type="text" class="form-control" placeholder="VAT Number" v-model="registration.client.vatNumber" />
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.vatNumber.isValidVat" class="help-block"><i class="fas fa-exclamation-triangle"></i> Invalid VAT number entered. The VAT number must be 10 digits and start with 4.</p>
						                	</div>
						            	</td>
					              	</tr>
					            </tbody>
					            <tbody>
					              	<tr>
						                <th><label class="required">Phone Number</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.telephone.$error}">
						                		<input type="text" class="form-control" placeholder="Phone Number" v-model="registration.client.telephone" />
												<p v-if="$v.registration.client.$error && !$v.registration.client.telephone.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the client's phone number.</p>
												<p v-if="$v.registration.client.$error && !$v.registration.client.telephone.isValidPhone" class="help-block"><i class="fas fa-exclamation-triangle"></i> Invalid Phone Number - It must be numeric, at least 3 digits and at most 17 digits. Can start with +.</p>
											</div>
						                </td>
					              	</tr>
					            </tbody>
					            <tbody v-if="registration.client.clientType == 'business'">
					              	<tr>
						                <th><label>Facsimile</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.facsimile.$error}">
						                		<input type="text" class="form-control" placeholder="Facsimile" v-model="registration.client.facsimile" />
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.facsimile.isValidPhone " class="help-block"><i class="fas fa-exclamation-triangle"></i> Invalid Phone Number - It must be numeric, at least 3 digits and at most 17 digits. Can start with +.</p>
						                	</div>
						                </td>
					              	</tr>
					            </tbody>
					            <tbody>
					            	<tr>
						                <th><label class="required">Postal Address</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.postal.$error}">
						                		<textarea rows="3" class="form-control" placeholder="Postal Address" v-model="registration.client.postal" ></textarea>
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.postal.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the postal address.</p>
						               			<p v-if="$v.registration.client.$error && !$v.registration.client.postal.minLength" class="help-block"><i class="fas fa-exclamation-triangle"></i> The postal address must have more than {{$v.registration.client.postal.$params.minLength.min}} characters.</p>
						                	</div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label class="required">Physical Address</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.physical.$error}">
						                		<textarea rows="3" class="form-control" placeholder="Physical Address" v-model="registration.client.physical"></textarea>
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.physical.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the physical address.</p>
							               		<p v-if="$v.registration.client.$error && !$v.registration.client.physical.minLength" class="help-block"><i class="fas fa-exclamation-triangle"></i> The physical address must have more than {{$v.registration.client.physical.$params.minLength.min}} characters.</p>
						               		</div>
						               	</td>
					              	</tr>
					              	<tr v-show="requestHasHardware">
						                <th>
						                  <label>Is the hardware delivery address the same as your physical address</label>
						                </th>
						                <td>
						                  <div
						                    class="button-grouped"
						                    role="group"
						                    aria-label="Basic example">
						                    <button
						                      type="button"
						                      class="btn btn-sm btn-outline-info" :class="{active : !showHardwareDeliveryAddress}"
						                      @click="hideHardwareDeliveryInput()">
						                      Yes
						                    </button>
						                    <button
						                      type="button"
						                      class="btn btn-sm btn-outline-info" :class="{active : showHardwareDeliveryAddress}"
						                      @click="showHardwareDeliveryInput()">
						                      No
						                    </button>
						                  </div>
						                </td>
				              		</tr>
					              	<tr v-show="showHardwareDeliveryAddress && requestHasHardware">
						                <th><label class="required">Hardware Delivery Address</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.hardware.$error}">
						                		<textarea rows="3" class="form-control" placeholder="Hardware Delivery Address" v-model="registration.client.hardware"></textarea>
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.hardware.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the physical address.</p>
							               		<p v-if="$v.registration.client.$error && !$v.registration.client.hardware.minLength" class="help-block"><i class="fas fa-exclamation-triangle"></i> The physical address must have more than {{$v.registration.client.hardware.$params.minLength.min}} characters.</p>
						               		</div>
						               	</td>
					              	</tr>
					              	<tr v-if="registration.client.clientType == 'individual' || registration.client.clientType == ''">
						                <th><label class="required">E-mail Address</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.email.$error}">
						                		<input type="text" class="form-control" placeholder="E-mail Address" v-model="registration.client.email"/>
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.email.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter your e-mail address.</p>
							               		<p v-if="$v.registration.client.$error && !$v.registration.client.email.email" class="help-block"><i class="fas fa-exclamation-triangle"></i> Invalid e-mail.</p>
											</div>
							            </td>
					              	</tr>
					              	<tr v-if="registration.client.clientType == 'individual' || registration.client.clientType == ''">
						                <th><label class="required">Confirm E-mail Address</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.email_confirmation.$error}">
						                		<input type="text" class="form-control" placeholder="Confirm E-mail Address" v-model="registration.client.email_confirmation"/>
						                		<p v-if="$v.registration.client.$error && !$v.registration.client.email_confirmation.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter your e-mail address.</p>
							               		<p v-if="$v.registration.client.$error && !$v.registration.client.email_confirmation.sameAsEmail" class="help-block"><i class="fas fa-exclamation-triangle"></i> The 2 emails are not the same.</p>
											</div>
							            </td>
					              	</tr>
					             </tbody>
					             <tbody v-if="registration.client.clientType == 'business'">
				              		<tr>
						                <th colspan="2">
						                  	<label class="font-weight-bold text-uppercase">Signatory</label>
						                </th>
				              		</tr>
				              		<tr>
						                <th><label class="required">Name</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.signatory.fullName.$error}" >
						                		<input type="text" class="form-control" placeholder="Name" v-model="signatory.fullName"/>
												<p class="help-block" v-if="$v.signatory.$error && !$v.signatory.fullName.required"><i class="fas fa-exclamation-triangle"></i> Please enter the signatory's name.</p>
												<p class="help-block" v-if="$v.signatory.$error && !$v.signatory.fullName.minLength"><i class="fas fa-exclamation-triangle"></i> The name must be 3 or more characters.</p>
											</div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label class="required">Identity Number/Passport</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.signatory.idNumber.$error}">
						                		<input type="text" class="form-control" placeholder="Identity Number"  v-model="signatory.idNumber" />
						                		<p class="help-block" v-if="$v.signatory.$error && !$v.signatory.idNumber.required"><i class="fas fa-exclamation-triangle"></i> Please enter the signatory's ID/Passport number.</p>
						                	</div>
						               	</td>
					              	</tr>
					              	<tr>
						                <th><label class="required">E-mail Address</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.signatory.email.$error}" >
						                		<input type="text" class="form-control" placeholder="E-mail Address"  v-model="signatory.email" />
						                    	<p class="help-block" v-if="$v.signatory.$error && !$v.signatory.email.required"><i class="fas fa-exclamation-triangle"></i> Please enter the signatory's e-mail address.</p>
						               			<p class="help-block" v-if="$v.signatory.$error &&!$v.signatory.email.email"><i class="fas fa-exclamation-triangle"></i> Invalid e-mail.</p>
						               		</div>
						               	</td>
					              	</tr>
					              	<tr>
						                <th><label class="required">Confirm E-mail Address</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.signatory.email_confirmation.$error}">
						                		<input type="text" class="form-control" placeholder="Confirm E-mail Address" v-model="signatory.email_confirmation"/>
						                		<p v-if="$v.signatory.$error && !$v.signatory.email_confirmation.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter your e-mail address.</p>
							               		<p v-if="$v.signatory.$error && !$v.signatory.email_confirmation.sameAsEmail" class="help-block"><i class="fas fa-exclamation-triangle"></i> The 2 emails are not the same.</p>
											</div>
							            </td>
					              	</tr>
					              	<tr>
						                <th><label class="required">Mobile Number</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.signatory.mobile.$error}">
						                		<input type="text" class="form-control" placeholder="Mobile Number"  v-model="signatory.mobile" />
												<p class="help-block" v-if="$v.signatory.$error && !$v.signatory.mobile.required"><i class="fas fa-exclamation-triangle"></i> Please enter the signatory's mobile number.</p>
												<p class="help-block" v-if="$v.signatory.$error && !$v.signatory.mobile.isValidPhone"><i class="fas fa-exclamation-triangle"></i> Invalid Phone Number - It must be numeric, at least 3 digits and at most 17 digits. Can start with +.</p>
											</div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label>Alternative Number</label></th>
						                <td>
											<div class="form-group" :class="{error: $v.signatory.telephone.$error}">
							                	<input type="text" class="form-control" placeholder="Alternative Number" v-model="signatory.telephone" />
	                                            <p class="help-block" v-if="$v.signatory.$error && !$v.signatory.telephone.isValidPhone"><i class="fas fa-exclamation-triangle"></i> Invalid Phone Number - It must be numeric, at least 3 digits and at most 17 digits. Can start with +.</p>
	                                        </div>
							            </td>
					              	</tr>
					            </tbody>
				            	<tbody>
				            		
				              		<!-- Show additional contacts -->
				              		<tr>
						                <th>
						                  <label
						                    >Is the signatory the sole contact or do you wish to specify
						                    additional contacts and their roles</label
						                  >
						                </th>
						                <td>
						                  <div
						                    class="button-grouped"
						                    role="group"
						                    aria-label="Basic example"
						                  >
						                    <button
						                      type="button"
						                      class="btn btn-sm btn-outline-info" :class="{active : !hasAdditional}"
						                      @click="hideContact()"
						                    >
						                      Yes
						                    </button>
						                    <button
						                      type="button"
						                      class="btn btn-sm btn-outline-info" :class="{active : hasAdditional}"
						                      @click="showContactForm()"
						                    >
						                      No
						                    </button>
						                  </div>
						                </td>
				              		</tr>
				            	</tbody>
				            	<contact v-if="contacts.length > 0"
					              v-for="(contact, position) in contacts"
					              :key="contact.id" :position="position" :contact="contact" :validate="validateContact" 
					              v-on:deleteItem="deleteContact"
					              ref="additionalContacts"
					            ></contact>
					           
				            	<tbody v-if="contacts.length > 0">
					              	<tr>
						                <td colspan="2" class="text-center">
						                  <button
						                    type="button"
						                    class="btn btn-success btn-sm"
						                    @click="addContact()"
						                  >
						                    <i class="fas fa-plus"></i> Add contact
						                  </button>
						                  <small class="d-block mt-2"
						                    >Note: You can always add additional contacts
						                    retrospectively.</small
						                  >
						                </td>
					              	</tr>
				            	</tbody>
				            	<tbody v-show="this.$store.state.includeMarketing">
					              	<tr>
						                <th><label>How did you hear about us?</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.registration.client.heardAbout.$error}">
							                  	<select class="form-control" v-model="registration.client.heardAbout">
								                    <option value="">-- Please select --</option>
								                    <option value="InternetSearch">Internet Search</option>
								                    <option value="Advert">I clicked an Advert</option>
								                    <option value="Referral">Somebody told me about you</option>
								                    <option value="PreviousClient">I used your services before</option>
								                    <option value="Publication">MyBroadband or other publication</option>
								                    <option value="Other">Other</option>
							                  	</select>
							                  	<p v-if="$v.registration.client.$error && !$v.registration.client.heardAbout.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please let us know how you heard about us.</p>
							                </div>
						                </td>
					              	</tr>
					            </tbody>
				          	</table>

				          	<div class="actions d-flex" :class="prevStepFromClientDetails() ? 'justify-content-between' : 'justify-content-end'">
					            <button type="button" class="btn btn-dark" @click="prevStep()" v-if="prevStepFromClientDetails()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End of Step -->

				        <!-- Start Step -->
				        <div v-if="step === 9">
				          	<h2 class="page-header">Payment Detail</h2>

				          	<ul class="nav nav-tabs responsive-tabs" id="myTab" role="tablist">
					            <li class="nav-item">
					              <a
					                class="nav-link"
					                :class="{active: !prepaidActiveTab}"
					                id="postpaid-tab"
					                data-toggle="tab"
					                href="#postpaid"
					                role="tab"
					                aria-controls="postpaid"
					                aria-selected="true"
					                @click="activePaymentTab = 'postpaid'"
					                >Postpaid</a
					              >
					            </li>
					            <li class="nav-item">
					              <a
					                class="nav-link"
					                :class="{active: prepaidActiveTab}"
					                id="prepaid-tab"
					                data-toggle="tab"
					                href="#prepaid"
					                role="tab"
					                aria-controls="prepaid"
					                aria-selected="false"
					                @click="activePaymentTab = 'prepaid'"
					                >Prepaid</a
					              >
					            </li>
				          	</ul>
				          
				          	<div class="tab-content porting" id="myTabContent">
				            	<div class="tab-pane fade" :class="{active: !prepaidActiveTab, show: !prepaidActiveTab}" id="postpaid" role="tabpanel" aria-labelledby="postpaid-tab">
				              
					              	<table class="table table-bordered">
						                <thead>
							                <tr>
							                    <th colspan="2">Bank Account</th>
							                </tr>
						                </thead>
					                	<tbody>
						                  	<tr>
							                    <th><label class="required">Bank Name</label></th>
							                    <td>
							                     	<div class="form-group" :class="{error: $v.registration.payment.bank_details.bankName.$error}">
								                      	<select class="form-control" v-model="registration.payment.bank_details.bankName" >
									                        <option value="">-- Select --</option>
									                        <option
									                          :value="bank.bank_name"
									                          v-for="bank in bankList"
									                          :key="bank.bank_name"
									                          >{{ bank.bank_name}}</option
									                        >
								                      	</select>
								                      	<p class="help-block" v-if="$v.registration.payment.$error && !$v.registration.payment.bank_details.bankName.required"><i class="fas fa-exclamation-triangle"></i> Please select the bank name.</p>
								                    </div>
							                    </td>
						                  	</tr>
					                 		<tr>
							                    <th><label class="required">Account Number</label></th>
							                    <td>
							                    	<div class="form-group" :class="{error: $v.registration.payment.bank_details.accountNumber.$error}">
							                    		<input type="text" class="form-control" placeholder="Account Number" v-model="registration.payment.bank_details.accountNumber" />
							                    		<p class="help-block" v-if="$v.registration.payment.$error && !$v.registration.payment.bank_details.accountNumber.required"><i class="fas fa-exclamation-triangle"></i> Please enter your account number.</p>
							                    		<p class="help-block" v-if="$v.registration.payment.$error && !$v.registration.payment.bank_details.accountNumber.isValidAccountNumber"><i class="fas fa-exclamation-triangle"></i> The account number is invalid. It must be a minimum 6 and maximum 11 numeric characters.</p>
							                		</div>
							                	</td>
							                </tr>
					                  		<tr v-show="!isBranchNumberDisabled">
							                    <th><label class="required">Branch Number</label></th>
							                    <td>
													<div class="form-group" :class="{error: $v.registration.payment.bank_details.branchNumber.$error}">
							                    		<input type="text" class="form-control" placeholder="Branch Number" v-model="registration.payment.bank_details.branchNumber" :disabled="isBranchNumberDisabled"/>
								                    	<p class="help-block" v-if="$v.registration.payment.$error && !$v.registration.payment.bank_details.branchNumber.required"><i class="fas fa-exclamation-triangle"></i> Please enter the branch number.</p>
								                    	<p class="help-block" v-if="$v.registration.payment.$error && !$v.registration.payment.bank_details.branchNumber.isValidBranchNumber"><i class="fas fa-exclamation-triangle"></i> The branch number is invalid. It must be 6 numeric characters.</p>
							                    	</div>
							                    </td>
					                  		</tr>
					                  		<tr>
							                    <th><label class="required">Account Type</label></th>
							                    <td>
							                    	<div class="form-group" :class="{error: $v.registration.payment.bank_details.accountType.$error}">
								                      	<select class="form-control" v-model="registration.payment.bank_details.accountType" @change="onAccountTypeSelection">
									                        <option value="">-- Select --</option>
									                        <option :value="element.value" v-for="(element, key) in accountTypes" :key="key">{{element.name}}</option>
								                      	</select>
								                      	<p class="help-block" v-if="$v.registration.payment.$error && !$v.registration.payment.bank_details.accountType.required"><i class="fas fa-exclamation-triangle"></i> Please select the account type.</p>
								                      	<p class="mt-1 text-danger" v-show="showTransmissionAccountWarning"><small>Please note that 95% of bank accounts are current accounts. Please be absolutely certain that your account is NOT, in fact, a current account before selecting another account type.</small></p>
								                    </div>
							                    </td>
					                  		</tr>
					                  		<tr>
							                    <td colspan="2">
							                    	<div class="mandate-options text-center my-3">
							                    		<a href="https://www.switchtel.co.za/documents/Debit_Order_Authority_and_Mandate_Terms.pdf" target="_blank" rel="noopener noreferrer" class="btn btn-secondary btn-sm" title="Click to open the file on a new tab"><i class="fas fa-external-link-alt mr-2"></i> Debit Order Authority and Mandate</a>
							                    		<a href="https://www.switchtel.co.za/documents/Switch_Telecom_Terms_and_Conditions.pdf" target="_blank" rel="noopener noreferrer" class="btn btn-secondary btn-sm" title="Click to open the file on a new tab"><i class="fas fa-external-link-alt mr-2"></i> Terms And Conditions</a>
							                    	</div>
													
													<!-- Checkbox -->
													<div class="form-group" :class="{error: $v.validation.postpaidMandate.$error}">
						                    			<label for="debit-order" class="option-input-label"><input type="checkbox" class="option-input with-check" id="debit-order" v-model="validation.postpaidMandate"/>
														I agree to the terms set out in the Debit Order Authority and Mandate for and on behalf of CLIENT as SIGNATORY (I warrant that I am duly authorised).</label>

								                      	<p class="help-block" v-if="$v.validation.postpaidMandate.$error && !$v.validation.postpaidMandate.checked"><i class="fas fa-exclamation-triangle"></i> Agreeing to the Debit Order Mandate is Required.</p>
								                    </div>

								                    <!-- Checkbox -->
													<div class="form-group" :class="{error: $v.validation.postpaidTnC.$error}">
						                    			<label for="postpaid-tnc" class="option-input-label"><input type="checkbox" class="option-input with-check" id="postpaid-tnc" v-model="validation.postpaidTnC"/>
														I agree to Switch Telecom's Terms and Conditions of service.</label>

								                      	<p class="help-block" v-if="$v.validation.postpaidTnC.$error && !$v.validation.postpaidTnC.checked"><i class="fas fa-exclamation-triangle"></i> Agreeing to the Terms And Conditions is Required.</p>
								                    </div>
							                    </td>
					                  		</tr>
					                	</tbody>
					              	</table>
				            	</div>
				            	<!-- End of tab-pane -->
				            
					            <div class="tab-pane fade"  :class="{active: prepaidActiveTab, show: prepaidActiveTab}"  id="prepaid" role="tabpanel" aria-labelledby="prepaid-tab">
					            	
					            	<div class="mandate-options text-center my-3">
			                            <a href="https://www.switchtel.co.za/documents/Prepaid_Mandate_Terms.pdf" target="_blank" rel="noopener noreferrer" class="btn btn-secondary btn-sm" title="Click to open the file on a new tab"><i class="fas fa-external-link-alt mr-2"></i> Prepaid Mandate</a>
			                            <a href="https://www.switchtel.co.za/documents/Switch_Telecom_Terms_and_Conditions.pdf" target="_blank" rel="noopener noreferrer" class="btn btn-secondary btn-sm" title="Click to open the file on a new tab"><i class="fas fa-external-link-alt mr-2"></i> Terms And Conditions</a>
					            	</div>

									<div class="form-group" :class="{error: $v.registration.payment.is_prepaid.$error}">
			                            <!-- Checkbox -->
			                			<label for="prepaid-mandate" class="option-input-label"><input type="checkbox" class="option-input with-check" id="prepaid-mandate" :value="true" v-model="registration.payment.is_prepaid"/>I agree to the terms set out in the Prepaid Mandate for and on behalf of CLIENT as SIGNATORY (I warrant that I am duly authorised).</label>
										
										<p class="help-block" v-if="$v.registration.payment.is_prepaid.$error && (!$v.registration.payment.is_prepaid.required || !$v.registration.payment.is_prepaid.checked)"><i class="fas fa-exclamation-triangle"></i> Agreeing to make payment in advance is Required.</p>
									</div>

									<!-- Checkbox -->
									<div class="form-group" :class="{error: $v.validation.prepaidTnC.$error}">
		                    			<label for="prepaid-tnc" class="option-input-label"><input type="checkbox" class="option-input with-check" id="prepaid-tnc" v-model="validation.prepaidTnC"/>
										I agree to Switch Telecom's Terms and Conditions of service.</label>

				                      	<p class="help-block" v-if="$v.validation.prepaidTnC.$error && !$v.validation.prepaidTnC.checked"><i class="fas fa-exclamation-triangle"></i> Agreeing to the Terms And Conditions is Required.</p>
				                    </div>
					            </div>
					            <!-- End of tab-pane -->
				         	</div>
				          	<!-- End of tab-content -->

				          	<div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Next <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End of Step -->

				        <!-- Start Step -->
				        <div v-if="step === 10">
				          	<h2 class="page-header">Supporting Documentation</h2>

				          	<p>In order to complete your application, we require the following supporting documentation.</p>
							
							<!-- RICA -->
				          	<div class="card mb-3">
					            <div class="card-body">
					              	<h5 class="text-uppercase">Rica</h5>
					              	<p class="text-muted">Copy of identification (SA ID Card / Green ID / Passport)</p>
					              	<div class="row">
						              	<div class="col-md-7">
						              		<div class="form-group" :class="{error: $v.registration.documentation.rica.$error}">
							              		<!-- First -->
				                    			<label for="upload-rica" class="option-input-label"><input type="radio" class="option-input with-check radio" id="upload-rica" :value="false" v-model="registration.documentation.rica.email_me" />
												I want to upload this document now</label>
													<!-- Second -->
				                    			<label for="email-rica" class="option-input-label"><input type="radio" class="option-input with-check radio" id="email-rica" :value="true" v-model="registration.documentation.rica.email_me" />Please email me and I'll reply to your email attaching a copy.</label>
					  							
					  							<p class="help-block" v-if="$v.registration.documentation.rica.$error && ($v.registration.documentation.rica.filename.required || $v.registration.documentation.rica.email_me.required)"><i class="fas fa-exclamation-triangle"></i> Please upload the Rica document or switch to upload the document later.</p>
				  							</div>	<!-- End of form-group -->					       
						              	</div>
					            		<div class="col-md-5">
											<div class="file-upload" v-if="registration.documentation.rica.email_me == false" :class="{active: ricaDocument != ''}">
							                    <div class="file-select">
							                        <div class="file-select-button" id="rica-file">Choose File</div>
							                        <div class="file-select-name" id="rica-noFile">{{ricaDocument}}</div> 
							                        <input type="file" name="chooseRicaFile" id="chooseRicaFile" @change="fileSelect($event, 'rica')">
							                    </div>
							                    <p class="d-block mt-2"><i class="fas fa-info-circle color-info"></i>Allowed formats: jpg, png, pdf, tiff, limit to 20MB</p>
							                </div>
					            		</div>
					            	</div> <!-- End of row -->
					            </div>
				          	</div>
				          
							<div class="card mb-3" v-if="showPoa">
				            	<div class="card-body">
				              		<h5 class="text-uppercase">Proof of address</h5>
				              		<p class="text-muted">We require proof of your physical address. Examples include a
					                recent utility bill, a certified bank statment, a copy of a
					                signed lease agreement, a Telkom Telephone bill or a rates and
					                taxes invoice.</p>

									<div class="row">
						                <div class="col-md-7">
						                	<div class="form-group" :class="{error: $v.registration.documentation.poa.$error}">
							                	<!-- First -->
							                	<label for="upload-poa" class="option-input-label"><input type="radio" class="option-input with-check radio" id="upload-poa" :value="false" v-model="registration.documentation.poa.email_me" />
												I want to upload this document now</label>

												<!-- Second -->
												<label for="email-poa" class="option-input-label"><input type="radio" class="option-input with-check radio" id="email-poa" :value="true" v-model="registration.documentation.poa.email_me" />Please email me and I'll reply to your email attaching a copy.</label>

												<p class="help-block" v-if="$v.registration.documentation.poa.$error && ($v.registration.documentation.poa.filename.required || $v.registration.documentation.poa.email_me.required)"><i class="fas fa-exclamation-triangle"></i> Please upload the Rica document or switch to upload the document later.</p>
											</div> <!-- End of form-group -->
					            		</div>
					            		<div class="col-md-5">
											<div class="file-upload" v-if="registration.documentation.poa.email_me == false" :class="{active: poaDocument != ''}">
							                    <div class="file-select">
							                        <div class="file-select-button" id="poa-file">Choose File</div>
							                        <div class="file-select-name" id="poa-noFile">{{poaDocument}}</div> 
							                        <input type="file" name="choosePoaFile" id="choosePoaFile" @change="fileSelect($event, 'poa')">
							                    </div>
							                    <p class="d-block mt-2"><i class="fas fa-info-circle color-info"></i>Allowed formats: jpg, png, pdf, tiff, limit to 20MB</p>
							                </div>
					            		</div>
					            	</div> <!-- End of row -->
				            	</div>
				          	</div>

				          	<div class="card mb-3" v-if="showPortingDocumentation">
				            	<div class="card-body">
				              		<h5 class="text-uppercase">Port supporting documentation</h5>
				              		<p class="text-muted">In order to port your number, we require a copy of your most recent tax invoice(s) from your current service provider(s) in respect of the number(s) to be ported.</p>

									<div class="row">
						                <div class="col-md-7">
						                	<div class="form-group" :class="{error: $v.registration.documentation.porting.$error}">
						              			<!-- First -->
							                	<label for="upload-porting" class="option-input-label"><input type="radio" class="option-input with-check radio" id="upload-porting" :value="false" v-model="registration.documentation.porting.email_me" />
												I want to upload this document now</label>

												<!-- Second -->
												<label for="email-porting" class="option-input-label"><input type="radio" class="option-input with-check radio" id="email-porting" :value="true" v-model="registration.documentation.porting.email_me" />Please email me and I'll reply to your email attaching a copy.</label>
												
												<p class="help-block" v-if="$v.registration.documentation.porting.$error && ($v.registration.documentation.porting.filename.required || $v.registration.documentation.porting.email_me.required )"><i class="fas fa-exclamation-triangle"></i> Please upload the Rica document or switch to upload the document later.</p>
											</div>
					            		</div>
					            		<div class="col-md-5">
											<div class="file-upload" v-if="registration.documentation.porting.email_me == false" :class="{active: portingDocument != ''}">
							                    <div class="file-select">
							                        <div class="file-select-button" id="porting-file">Choose File</div>
							                        <div class="file-select-name" id="porting-noFile">{{portingDocument}}</div> 
							                        <input type="file" name="choosePortingFile" id="choosePortingFile" @change="fileSelect($event, 'porting')">
							                    </div>
							                    <p class="d-block mt-2"><i class="fas fa-info-circle color-info"></i>Allowed formats: jpg, png, pdf, tiff, limit to 20MB</p>
							                </div>
					            		</div>
					            	</div> <!-- End of row -->
				            	</div>
				          	</div>

				          	<div class="card mb-3">
				            	<div class="card-body">
				              		<h5 class="text-uppercase">Contract</h5>
				              		<p>
					                We will email you a contract as soon as we have verified and
					                vetted the information that you have provided us. Please allow 1
					                to 2 working days for vetting to be concluded. Once you receive
					                the contract, please sign it and reply to our email with the
					                signed contract.
					              	</p>
				            	</div>
				          	</div>

				          	<div class="actions d-flex justify-content-between">
				            	<button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Submit <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
					        </div>
				        </div>
				        <!-- End of Step -->

				        <!-- Start Step -->
				        <div v-if="step === 11">
							<thank-you></thank-you>
				        </div>
				        <!-- End of Step -->

				        <!-- Start Step -->
				        <div v-if="step === 12">
				          	<table class="table table-bordered">
				            	<thead>
					              	<tr>
					                	<th colspan="2">Contact Details</th>
					              	</tr>
				            	</thead>
				            	<tbody>
					              	<tr>
					                	<th><label class="required">Name</label></th>
					                	<td>
					                		<div class="form-group" :class="{error: $v.potential_client.name.$error}">
						                		<input type="text" class="form-control" placeholder="Full Name" v-model="potential_client.name" />
		                                        <p v-if="$v.potential_client.$error && !$v.potential_client.name.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter your name.</p>
		                                        <p v-if="$v.potential_client.$error && !$v.potential_client.name.minLength" class="help-block"><i class="fas fa-exclamation-triangle"></i> The full name must be {{$v.potential_client.name.$params.minLength.min}} or more characters.</p>
		                                    </div>
					                	</td>
					              	</tr>
					              	<tr>
					                	<th><label>Company Name (If Applicable)</label></th>
					                	<td>
					                		<div class="form-group">
						                		<input type="text" class="form-control" placeholder="Company name" v-model="potential_client.companyName" />
		                                    </div>
					                	</td>
					              	</tr>
					              	<tr>
						                <th><label class="required">E-mail</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.potential_client.email.$error}">
						                		<input type="text" class="form-control" placeholder="E-mail Address" v-model="potential_client.email"/>
						                		<p v-if="$v.potential_client.$error && !$v.potential_client.email.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter your e-mail address.</p>
							               		<p v-if="$v.potential_client.$error && !$v.potential_client.email.email" class="help-block"><i class="fas fa-exclamation-triangle"></i> Invalid e-mail.</p>
											</div>
							            </td>
					              	</tr>
					              	<tr>
						                <th><label class="required">Contact Number</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.potential_client.telephone.$error}">
						                		<input type="text" class="form-control" placeholder="Phone Number" v-model="potential_client.telephone" />
												<p v-if="$v.potential_client.$error && !$v.potential_client.telephone.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please enter the client's phone number.</p>
												<p v-if="$v.potential_client.$error && !$v.potential_client.telephone.isValidPhone" class="help-block"><i class="fas fa-exclamation-triangle"></i> Invalid Phone Number - It must be numeric, at least 3 digits and at most 17 digits. Can start with +.</p>
											</div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label class="required">Region</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.potential_client.region.$error}">
							                  	<select class="form-control" v-model="potential_client.region">
													<option value="">-- Please select --</option>
													<option value="EC">Eastern Cape</option>
													<option value="FS">Free State</option>
													<option value="GT">Gauteng</option>
													<option value="KZN">Kwazulu Natal</option>
													<option value="LP">Limpopo</option>
													<option value="MP">Mpumalanga</option>
													<option value="NC">Northern Cape</option>
													<option value="NW">North West</option>
													<option value="WC">Western Cape</option>
													<option value="INT">International</option>
							                  	</select>
							                  	<p v-if="$v.potential_client.$error && !$v.potential_client.region.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please select your region.</p>
							                </div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label class="required">Where did you hear about us?</label></th>
						                <td>
						                	<div class="form-group" :class="{error: $v.potential_client.heardAbout.$error}">
							                  	<select class="form-control" v-model="potential_client.heardAbout">
								                    <option value="">-- Please select --</option>
								                    <option value="InternetSearch">Internet Search</option>
								                    <option value="Referral">Somebody told me about you</option>
								                    <option value="Advert">I clicked an Advert</option>
								                    <option value="PreviousClient">I used your services before</option>
								                    <option value="Other">Other</option>
							                  	</select>
							                  	<p v-if="$v.potential_client.$error && !$v.potential_client.heardAbout.required" class="help-block"><i class="fas fa-exclamation-triangle"></i> Please select an option.</p>
							                </div>
						                </td>
					              	</tr>
					              	<tr>
						                <th><label>Comments/Question</label></th>
						                <td>
						                	<div class="form-group">
						                  		<textarea rows="3" class="form-control" placeholder="Comments" v-model="potential_client.comments" ></textarea>
						                  	</div>
						                </td>
					              	</tr>
				            	</tbody>
				          	</table>

				          	<div class="actions d-flex justify-content-between">
					            <button type="button" class="btn btn-dark" @click="prevStep()"><i class="fas fa-angle-left"></i> Previous</button>
						        <button type="button" class="btn btn-dark" @click="nextStep()" :disabled="!isCurrentStepValid || isBtnLoading">Submit <i class="fas fa-angle-right" v-if="!isBtnLoading"></i> <i class="fas fa-spinner fa-spin" v-if="isBtnLoading"></i></button>
				          	</div>
				        </div>
				        <!-- End of Step -->

				         <!-- Start Step -->
				        <div v-if="step === 13">
				        	<thank-you-quote></thank-you-quote>
				        </div>
				        <!-- End of Step -->

				         <!-- Start Step -->
				        <div v-if="step === 14">
							<transfer-services :allowPrevStep="this.serviceSelection == 'quoteWithTransfer'" :serviceTransfer="serviceTransfer" @prevStep="prevStep()" @nextStep="nextStep()"></transfer-services>
				        </div>
				        <!-- End of Step -->

				        <div class="progress mt-5">
					        <div
					            class="progress-bar bg-info"
					            :class="[animateProgressBar]"
					            role="progressbar"
					            :style="{ width: progressWith }"
					            aria-valuenow="25"
					            aria-valuemin="0"
					            aria-valuemax="100"
					        ></div>
				        </div>
		      		</form>


		    	</div>
		    	<!-- End of col-md-4 -->
		  	</div>
		  	<!-- End of row signup -->

		</div> 
		<!-- End of container -->
	</div>
	<!-- End of div main -->

</template>

<script>

import store from  "@/store/index"; //vuex store
import QuoteNumber from "@/components/QuoteDisplay";
import Reseller from "@/components/ResellerDisplay";
import BreadcrumbHeader from "@/components/BreadcrumbHeader";
import PageLoader from "@/components/PageLoader";
import ThankYou from "@/views/ThankYou";
import ThankYouQuote from "@/views/ThankYouQuote";
import TransferServices from "@/components/TransferServices";
import Recaptcha from "@/components/Recaptcha";
import AdditionalContact from "@/components/AdditionalContact";
import AdditionalNumber from "@/components/AdditionalNumber";
import { required, requiredIf, minLength, minValue, between, email, helpers, sameAs } from 'vuelidate/lib/validators';
import { isValidVat, isValidPhone, isValidRegistration, isValidAccountNumber, isValidBranchNumber } from "@/validators";  //Our custom validators
import { scrollToError, scrollTop, } from "@/functions";  //Our custom validators

export default {
  	name: "Signup",
  	components: {
		'quote-number': QuoteNumber,
		'reseller': Reseller,
		'breadcrumb-header': BreadcrumbHeader,
		'page-loader' : PageLoader,
		'contact': AdditionalContact,
		'number': AdditionalNumber,
		'thank-you': ThankYou,
		'thank-you-quote': ThankYouQuote,
  		'captcha-validate' : Recaptcha,
  		'transfer-services': TransferServices,
  	},
   
  	mounted() {
	    //We get the first page content - step 1
		var url               = "";
		this.loading          = true;
		this.referring_domain = document.referrer;

        const params = new Proxy(new URLSearchParams(window.location.search), {
            get: (searchParams, prop) => searchParams.get(prop),
        });
        let pathReferrer = params.referrer;
        if(pathReferrer == "unlimitedvoip.co.za") {
            this.referring_domain = "unlimitedvoip.co.za";
        }

        //Attempt to load tracking cookie
        let trackingCookie = document.cookie.match('(^|;) ?swt_wp_marketing=([^;]*)(;|$)');
        if(trackingCookie) {
            this.tracking_cookie = trackingCookie[2];
        }

	    if(this.$route.query.rsl){
        	this.reseller_id = this.$route.query.rsl;
      	}

      	if(this.$route.query.qid){
        	this.quote_id = this.$route.query.qid;
      	}

      	if(this.$route.query.tos){
        	this.transfer_of_service = this.$route.query.tos;
      	}

      	if(store.state.token){
      		this.fetchContent();
      	}

      	if(!store.state.token){
      		this.fetchToken().
	      		then(function(data){
	      			this.fetchContent();
	      		}.bind(this));
      	}
  	},

  	data() {
    	return {
    		showHardwareDeliveryAddress: false,
    		showTransmissionAccountWarning: false,
    		requestId: "",			// Request id
    		reseller_id: "",        // Reseller ID from the url
    		quote_id: "",			// Quote ID from the url
    		quote_id_uncoded: "",	// Quote ID filled after successful processing from the API
    		transfer_of_service: "", 

    		referring_domain: null,   // referring domain for reseller links
    		tracking_cookie: null,    // referring domain for reseller links

    		counter: 1, 			// This will be used to track the current step in the matrix depending on the service selected
    		step: 1,     			// This tracks the current step we are on
    		
			loading: false,			// Controls page loader
			isBtnLoading: false,	// Controls button loader icon, as well as disabling the button to avoid double-clicking (race condition)  
			showStepTransition: false,

			serviceSelection: "voipLineService", // Step 1 
			packageOptions: [], 	// List the different package/call tariff options
			contentloaded: false,

			validateContact: 0, 	// Controls validating the addditional contact component
			validateNewNumber: 0,	// Controls validating the additional number component
			validateCaptcha: 0,

    		confirmation: null,  	// Controls the radio buttons on the order confirmation page    		
    		orderConfirmed: false,

	      	hasAdditional: false,  	// Determines if the client has additional contacts - it will be used to show the add additional component
	      	
	      	unlimitedTrunkChannels: [4, 8, 16],
	      	isUnlimitedPackage: false,
	      	ddiNumbers: 0,
	      	extensions: 0,

	      	activeFilter: 'all',

	      	serviceTransfer: {
	      		clientZoneAccountNumber: null,
	      		partialTransfer: null
	      	},

	      	signatory: {
	      		fullName:null,
	            email:null,
	            email_confirmation: null,
	            telephone:null,
	            mobile:null,
	            idNumber:null,
	            sendBilling:null,
	            sendTechnical:null,
	            sendOrdering:true,
	            sendMarketing:null,
	            type:null,
	            signatory:null
	      	},
	      	contacts: [],
	      	numbers: [
		      	{
		      		area_code: "",
	          		is_sequential: false,
	          		number_selection: null, //string for 'range' or 'individual'
	          		number_range: null,
		      	}
	      	],
	      	

	      	serviceList: [], 		//for step 1
	      	
	      	areaCodes: [], 			//for step 2 - number selection
	      	phoneList: [],
	      	phoneDisplay: [],
	      	allPhones: [], 

	      	errors: [],
	      	//for validation
	      	validation: {
	      		accountPaid: false,
	      		numberLinkedToActiveService: false,
	      		areaConfirmation: false,
	      		prepaidMandate: false,
	      		postpaidMandate: false,
	      		prepaidTnC: false,
	      		postpaidTnC: false,
	      	},
	      	
	     	baseExtension: [],
	      	callRecordingList: [],
	      	voiceProList: [],
	      	bankList: [], //for payment details
	      	accountTypes: [], //for payment details
	      	
	      	currentIndex: 0,
	      	cart: [],
	      	phoneOrders: [],
	      	cartTotals: [],
	      	bundleOptions: [],
	      	telephone: '',
	      	singleTelephone: '',
	      	choseFile: '',
	      	activeNumberSelectionTab: 'porting', //by default
	      	activePaymentTab: 'postpaid', //by default
	      	
	      	//How these fields match with the API fields
	      	matrix: {
		        1:  1, 	//service selection
                2:  2, 	//package
                3:  3, 	//number selection
                4:  8, 	//switchboard custom
                5:  9, 	//trunk custom
                6:  4, 	//phone order
                7:  5, 	//order confirmation
                8:  11, //client details
                9:  7,  //payment details
                10: 12, //supporting documentation
                11: 13,	//completed - thank you page
                12: 6,  //abridged client form
                13: 14, //completed - thank you quote page
                14: 15, //transfer of services
	      	},
	      	line_user_flow:{
	      		1: 1,  //service selection
	      		2: 2,  //package selection
	      		3: 3,  //number selection
	      		4: 6,  //phone order
	      		5: 7,  //order confirmation
	      		6: 8,  //client details
	      		7: 9,  //payment details
	      		8: 10, //supporting document
	      		9: 11, //completed - thank you page
	      	},
	      	trunk_user_flow:{
	      		1: 1,  //service selection
	      		2: 2,  //package selection
	      		3: 3,  //number selection
	      		4: 5,  //trunk custom
	      		5: 7,  //order confirmation
	      		6: 8,  //client details
	      		7: 9,  //payment details
	      		8: 10, //supporting documentation
	      		9: 11, //completed - thank you page
	      	},
	      	vpbx_user_flow:{
	      		1: 1,  //service selection
	      		2: 4,  //switchboard custom
	      		3: 3,  //number selection
	      		4: 2,  //package selection
	      		5: 5,  //trunk custom (number of channels)
	      		6: 6,  //phone order
	      		7: 7,  //order confirmation
	      		8: 8,  //client details
	      		9: 9,  //payment details
	      		10: 10,//supporting documentation
	      		11: 11,//completed - thank you page
	      	},
	      	call_diversion_user_flow:{
	      		1: 1,  //service selection
	      		2: 7,  //order confirmation
	      		3: 8,  //client details
	      		4: 9,  //payment details
	      		5: 10, //supporting documentation
	      		6: 11, //completed - thank you page
	      	},
	      	quote_user_flow:{
	      		1: 1, //service selection (user will select quote)
	      		2: 8, //client details
	      		3: 9, //payment details
	      		4: 10, //supporting document
	      		5: 11, //completed
	      	},
	      	linked_quote_user_flow:{
	      		1: 8, //client details (the user is using a direct link from a quote)
	      		2: 9, //payment details
	      		3: 10, //supporting document
	      		4: 11, //completed
	      	},
	      	linked_quote_with_porting_flow:{
               	1: 3, //number selection
               	2: 8,  //client details (the user is using a direct link from a quote)
               	3: 9,  //payment details
               	4: 10, //supporting document
               	5: 11, //completed
            },
	      	transfer_services_flow:{
	      		1: 14, //transfer of services details (the user is using a direct link from a quote that has tos)
	      		2: 8, //client details
	      		3: 9, //payment details
	      		4: 10, //supporting document
	      		5: 11, //completed
	      	},
	      	quote_with_tos_flow: {
	      		1: 1, //service selection (user will select quote - the quote however is linked to a transfer of service)
	      		2: 14, //transfer of services details
	      		3: 8, //client details
	      		4: 9, //payment details
	      		5: 10, //supporting document
	      		6: 11, //completed
	      	},

	      	serviceConfirmation:{
	      		services: null,
	      		costs: null
	      	},
	      	registration: {
		        service: null, //Step service selection,
		        quote_number:null,
		        hasPort: false,			//Quote has port
		        quantity: 1,
		        package: "", //Step package selection
		        existingQuoteHasHardware: false,
		        porting: {
			        //Step number selection
			        number_selection: null, //string for 'range' or 'individual'
			        is_sequential: false,
			        individual_numbers: [],
			        number_range_start: null,
			        number_range_end: null,
			        account_number: null,
			        account_holder: null,
			        is_prepaid: null,
			        has_existing_service: null,
			        retain_existing: null,
		        },
	        	new_number: [
		        	{
			      		area_code: "",
		          		is_sequential: false,
		          		number_selection: null, //string for 'range' or 'individual'
		          		number_range: null,
			      	}
	        	],
	        	trunk: {
	        		channels: null, 
	        	},
	        	switchboard: {
	          		//swithboard custom
		          	extensions: null,
		          	call_recording_option: 0,
		          	voice_pro: 0,
	        	},
	        	hardware: [
            		{
              			id: "",
              			quantity: null
            		}
	        	],

	        	is_satisfied: null,
            	please_contact: null,
            	is_undecided: null,
            	
	        	client: {
	          		clientType: '',
	          		clientName: null,
	          		idNumber: null,
	          		vatNumber: null, 
	          		registrationNumber: null,
	          		telephone: null,
	          		mobile: null,
	          		facsimile: null,
	          		postal: null,
	          		physical: null,
                    hasHardware: false,
                    useHardwareAdrress: false,
	          		hardware: null,
	          		email: null,
	          		email_confirmation: null,
	          		heardAbout: '',
	          		businessClient: null,
	        	},
	        	users:[],
	        	payment: {
	          		bank_details: {
	            		bankName: '',
	            		accountNumber: null,
	            		branchNumber: null,
	            		accountType: ''
	          		},
	          		is_prepaid: false,
	          	},
	          	documentation: {
	            	rica: {
		                email_me: null,
		                document: "",
		                filename: "",
		            },
		            poa: {
		                email_me: null,
		                document: "",
		                filename: ""
		            },
		            porting:{
		                email_me: null,
		                document: "",
		                filename: ""
		            }
	          	}
	        },

	        //User detail who wants a quote
	        potential_client: {
	        	name: '',
	        	companyName: '',
	        	email: '',
	        	telephone: '',
	        	region: '',
	        	heardAbout: '',
	        	comments: ''
	        }
	    };
	}, //end of data
  	
  	/**
  	 * Vuelidate validation rules
  	 * 
  	 * @type {Object}
  	 */
  	validations:{
	   	
	   	//checkbox validations
	   	validation: {
      		accountPaid: {
      			checked: function(val) {
				    return val == true || this.completingNewNumber;
				}
      		},
      		numberLinkedToActiveService: {
      			checked: function(val) {
				    return val == true || this.completingNewNumber;
				}
      		},
      		areaConfirmation: {
      			checked: function(val) {
				    return val == true || this.completingPorting;
				}
      		},

      		postpaidMandate: {
      			checked: function(val) {
				      return val == true || this.completingPrepaid;
				}	
      		},
      		prepaidTnC: {
      			checked: function(val) {
				      return val == true || this.completingPostpaid;
				}	
      		},

	      	postpaidTnC: {
      			checked: function(val) {
				      return val == true || this.completingPrepaid;
				}	
      		},
      	},

	   	//Checkboxes on the order confirmation page
	   	confirmation:{ required },

  		//Porting single telephone : eg: when voip line is selected
  		singleTelephone: {
  			required: requiredIf(function(){
  				return this.completingPorting && this.serviceSelection == 'voipLineService';
  			})
  		},

  		//Porting individual number : eg: when trunk or hosted switchboard is selected
  		telephone: {
  			required: requiredIf(function(){
  				return this.completingPorting && this.serviceSelection != 'voipLineService' && this.registration.porting.number_selection == 'individual' && !this.registration.porting.number_range_end && !this.registration.porting.number_range_start && this.registration.porting.individual_numbers.length == 0;
  			})
  		},

  		//Main registration object
  		registration: {
  			//Service selection
  			service: {
  				required
  			},

  			quote_number: {
  				required: requiredIf(function(){
  					return this.registration.service == -1;
  				})
  			},
  			

  			//Package selection
  			package: {
  				required
  			},
  			//Number porting
  			porting: {
		        //Step number selection
		        
		        number_selection: {
		        	required: requiredIf(function(){
		        		return this.serviceSelection != 'voipLineService' && this.completingPorting;
		        	})
		        }, //string for 'range' or 'individual'
		        

		        // individual_numbers: [],
		        // 
		        number_range_start: {
		        	required: requiredIf(function(){
		        		return this.completingPorting && this.serviceSelection != 'voipLineService' && this.registration.porting.number_selection == 'range' && this.registration.porting.individual_numbers.length == 0;
		        	})
		        },
		        number_range_end: {
		        	required: requiredIf(function(){
		        		return this.completingPorting && this.serviceSelection != 'voipLineService' && this.registration.porting.number_selection == 'range' && this.registration.porting.individual_numbers.length == 0;
		        	})
		        },
		        
		        //Always required
		        account_number: {
		        	required: requiredIf(function(){
	      				return this.completingPorting;
	      			})	
		        },
		        account_holder: {
		        	required: requiredIf(function(){
	      				return this.completingPorting;
	      			})	
		        },
		        is_prepaid: {
		        	required: requiredIf(function(){
	      				return this.completingPorting;
	      			})	
		        },
		        has_existing_service: {
		        	required: requiredIf(function(){
	      				return this.completingPorting;
	      			})	
		        },
		        retain_existing: {
		        	required: requiredIf(function(){
	      				return this.completingPorting && this.registration.porting.has_existing_service == true;
	      			})	
		        },
	        },
	       
			//swithboard custom
        	switchboard: {
	          	extensions: {
	          		required,
	          		minValue: minValue(10)
	          	},
	          	call_recording_option: {
	          		required
	          	},
	          	voice_pro: {
	          		required
	          	},
        	},

        	trunk: {
        		channels: {
        			required,
        			minValue: minValue(4)
        		}
        	},
 
			//Client Details
    		client: {
	      		clientType: {
	      			required
	      		},
	      		clientName: {
	      			required,
	      			minLength: minLength(2)
	      		},
	      		idNumber: {
	      			required: requiredIf(function(){
	      				return !this.isBusinessClient;
	      			})
	      		},
	      		vatNumber: { 
	      			isValidVat 
	      		}, 
	      		registrationNumber: { 
	      			required: requiredIf(function(){
	      				return this.isBusinessClient;
	      			}),
	      			isValidRegistration 
	      		},
	      		telephone: { 
	      			required, 
	      			isValidPhone 
	      		},
	      		facsimile: { 
	      			isValidPhone 
	      		},
	      		postal: {
	      			required,
	      			minLength: minLength(5)
	      		},
	      		physical: {
	      			required,
	      			minLength: minLength(5)
	      		},
	      		hardware: {
                    required: requiredIf(function(){
                        return this.showHardwareDeliveryAddress;
                    }),
                    minLength: minLength(5)
	      		},
	      		email: {
	      			required: requiredIf(function(){
	      				return !this.isBusinessClient;
	      			}),
	      			email,
	      		},
	      		email_confirmation: {
	      			required: requiredIf(function(){
	      				return !this.isBusinessClient;
	      			}),
	      			sameAsEmail: function(val){
	      				return this.isBusinessClient || sameAs('email');
	      			}
	      		},
	      		heardAbout: {
	      			required: requiredIf(function(){
	      				return this.$store.state.includeMarketing;
	      			})
 	      		}
    		},	
    		
    		//Payment details
        	payment: {
          		bank_details: {
            		bankName: {
                     	required: requiredIf(function(){
		      				return this.completingPostpaid;
		      			})
            		},
            		accountNumber: {
            			required: requiredIf(function(){
		      				return this.completingPostpaid;
		      			}),
		      			isValidAccountNumber
            		},
            		branchNumber: {
            			required: requiredIf(function(){
		      				return this.completingPostpaid;
		      			}),
		      			isValidBranchNumber
            		},
            		accountType: {
            			required: requiredIf(function(){
		      				return this.completingPostpaid;
		      			})
            		}
          		},
          		is_prepaid: {
          			required: requiredIf(function(){
	      				return this.completingPrepaid;
	      			}),
	      			checked: function(val) {
					      return val == true || this.completingPostpaid;
					}	
          		},
          	},
          	documentation: {
            	rica: {
	                email_me: {
	                	required: requiredIf(function(){
		      				return !this.registration.documentation.rica.filename;
		      			})
	                },
	                filename: {
	                	required: requiredIf(function(){
		      				return this.registration.documentation.rica.email_me == false;
		      			})
	                },
	            },
	            poa: {
	                email_me: {
	                	required: requiredIf(function(){
		      				return !this.registration.documentation.poa.filename && this.showPoa;
		      			})
	                },
	                filename: {
	                	required: requiredIf(function(){
		      				return this.registration.documentation.poa.email_me == false && this.showPoa;
		      			})
	                },
	            },
	            porting:{
	                email_me: {
	                	required: requiredIf(function(){
		      				return !this.registration.documentation.porting.filename && this.showPortingDocumentation;
		      			})
	                },
	                filename: {
	                	required: requiredIf(function(){
		      				return this.registration.documentation.porting.email_me == false && this.showPortingDocumentation;
		      			})
	                }
	            }
          	} //end of documentation 	

  		}, // end of registration

  		//Signatory object
	    signatory: {
	    	fullName: {
	    		required: requiredIf(function(){
      				return this.isBusinessClient;
      			}),
      			minLength: minLength(3),
	    	},
	    	idNumber:{
	    		required: requiredIf(function(){
      				return this.isBusinessClient;
      			})
	    	},
	    	email: {
	    		required: requiredIf(function(){
      				return this.isBusinessClient;
      			}),
      			email
	    	},
	    	email_confirmation: {
	    		required: requiredIf(function(){
      				return this.isBusinessClient;
      			}),
      			sameAsEmail: function(val){
      				return !this.isBusinessClient || sameAs('email');
      			}
	    	},
	    	mobile: {
	    		required: requiredIf(function(){
      				return this.isBusinessClient;
      			}),
      			isValidPhone
	    	},
	    	telephone: {
	    		isValidPhone
	    	}
	    }, //end of signatory

	    potential_client: {
	        	name: {
	        		required,
	        		minLength: minLength(3)
	        	},
	        	companyName: {
	        	},
	        	email: {
	        		required,
	        		email
	        	},
	        	telephone: {
	        		required,
	        		isValidPhone
	        	},
	        	region: {
	        		required
	        	},
	        	heardAbout: {
	        		required
	        	},
	        	comments: {
	        	}
	        }, //end of potential_client

  	}, //End of validations

  	watch: {
  		'registration.service': function(){
  			this.resetPortingData();
  			this.resetNewNumberData();
  		},
  		'telephone': function(){
  			if(this.registration.porting.number_selection == 'individual' && this.telephone != '')
  			{
  				//reset single telephone number fields
  				this.resetSingleNumberFields();
  				//reset the range fields
  				this.resetRangeFields();	
  			}
  		},

  		'registration.porting.individual_numbers': function(){
  			if(this.registration.porting.number_selection == 'individual' && this.registration.porting.individual_numbers.length != 0)
  			{
  				//reset the range fields
  				this.resetRangeFields();
  			}
  		},

  		'registration.porting.number_range_start': function(){

  			if(this.registration.porting.number_selection == 'range' && this.registration.porting.number_range_start != '')
  			{
  				//reset the individual porting fields
  				this.resetIndividualFields();
  				this.resetSingleNumberFields();
  			}
  		},

  		'registration.porting.number_range_end': function(){

  			if(this.registration.porting.number_selection == 'range' && this.registration.porting.number_range_end != '')
  			{
  				//reset the individual porting fields
  				this.resetIndividualFields();
  				this.resetSingleNumberFields();
  			}
  		},

  		'registration.porting.has_existing_service': function(){
  			if(!this.registration.porting.has_existing_service){
  				this.registration.porting.retain_existing = null;
  			}
  		},

  		/**
  		 * Controls setting the confirmation fields on the service selection Confirmation page
  		 * @return void
  		 */
  		confirmation: function()
  		{
			this.registration.is_satisfied   = this.confirmation === 'satisfied';
			this.registration.please_contact = this.confirmation === 'confirm';
			this.registration.is_undecided   = this.confirmation === 'undecided';
  		},

  		/**
  		 * @return void
  		 */
  		'registration.client.clientType': function()
  		{
  			//We set the businessClient field on the main registration client object
  			this.registration.client.businessClient = this.registration.client.clientType === 'business';
  		
  			if(this.registration.client.clientType == 'business')
  			{
				this.registration.client.idNumber           = '';  //We will get the id number from the signatory object
				this.registration.client.email              = '';  //We will get the email from the signatory object
				this.registration.client.email_confirmation = '';  //We will get the email from the signatory object

  				//We reset the signatory object, as we will be getting these values as the user enters them
  				this.signatory.fullName = '';
		        this.signatory.email = '';
		        this.signatory.email_confirmation = '';
		        this.signatory.telephone = '';
		        this.signatory.mobile = '';
		        this.signatory.idNumber = '';
		        this.signatory.sendBilling = true;
		        this.signatory.sendTechnical = true;
		        this.signatory.sendOrdering = true;
		        this.signatory.sendMarketing = true;
		        this.signatory.type = null;
		        this.signatory.signatory = true;
  			}
  		},

  		'registration.client': 
  		{
  			handler: function (after, before) {

	  			if(this.registration.client.clientType == 'individual')
	  			{
	  				//We set the signatory object
		  			this.signatory.fullName = this.registration.client.clientName;
			        this.signatory.email = this.registration.client.email;
			        this.signatory.email_confirmation = this.registration.client.email;
			        this.signatory.telephone = this.registration.client.telephone;
			        this.signatory.mobile = '';
			        this.signatory.idNumber = this.registration.client.idNumber;
			        this.signatory.sendBilling = true;
			        this.signatory.sendTechnical = true;
			        this.signatory.sendOrdering = true;
			        this.signatory.sendMarketing = true;
			        this.signatory.type = null;
			        this.signatory.signatory = true;
	  			}   
            
            },
            deep: true
  		},

  		'registration.porting': 
  		{
  			handler: function (after, before) {

  				if(this.completingPorting){
  					//clear new_number data
	  				this.resetNewNumberData();
  				}
            },
            deep: true
  		},

  		'registration.new_number': 
  		{
  			handler: function (after, before) {

  				//Only if the fields didn't change because of a reset
  				if(this.completingNewNumber){
  					//clear porting data
	  				this.resetPortingData();

	  				if(this.registration.new_number.number_selection != '' && this.registration.new_number.number_selection == 'individual'){
	  					this.registration.new_number.number_range = null;
	  				}
  				}
	  			
            },
            deep: true
  		},

  		'registration.payment.bank_details.bankName': function(selectedBankName){
	      	if(!selectedBankName){
       			this.registration.payment.bank_details.branchNumber = '';
            	return;
       		}

       		var selectedCode = '';

            for(var i in this.bankList){
                if(this.bankList[i].bank_name == selectedBankName){
                    selectedCode = this.bankList[i].branch_code;
                    break;
                }
            }

            this.registration.payment.bank_details.branchNumber = selectedCode;
        },

  		'registration.payment.is_prepaid': function(){
  			if(this.registration.payment.is_prepaid){
  				//we clear banking details 
				this.registration.payment.bank_details.bankName      = "";
				this.registration.payment.bank_details.accountNumber = null;
				this.registration.payment.bank_details.branchNumber  = null;
				this.registration.payment.bank_details.accountType   = "";
  				
  				//We clear the validation checkbox
  				this.validation.postpaidMandate = false;
  				this.validation.postpaidTnC = false;
  			}
  		},

  		'registration.documentation': {
  			handler: function (after, before) {

  				if(this.registration.documentation.rica.email_me == true){
  					this.registration.documentation.rica.filename = '';
  					this.registration.documentation.rica.document = '';
  				}

  				if(this.registration.documentation.poa.email_me == true){
  					this.registration.documentation.poa.filename = '';
  					this.registration.documentation.poa.document = '';
  				}

  				if(this.registration.documentation.porting.email_me == true){
  					this.registration.documentation.porting.filename = '';
  					this.registration.documentation.porting.document = '';
  				}
            },
            deep: true
  		}

  	},

  	computed: {

  		loadCaptcha: function(){
  			return this.step == 1 && this.contentloaded;
  		},
  		animateProgressBar: function(){
  			var additionalClasses = [];

  			if(this.step != 11 && this.step != 13){
  				additionalClasses = ['progress-bar-striped', 'progress-bar-animated'];
  			}

  			return additionalClasses;
  		},

  		getQuoteNumber: function(){
  			//The user entered the quote number on step 1
  			if(this.registration.quote_number){
  				return this.registration.quote_number;
  			}

  			//The user clicked the signup link inside a quote document
  			if(this.quote_id){
  				return this.quote_id_uncoded;
  			}

  			//if quote_id_uncoded is not null, (for instance, if set by the cookie on the API side), return it
  			return this.quote_id_uncoded ? this.quote_id_uncoded  : '';
  		},

  		/**
  		 * Determines showing the quote number component, at the top right of the signup page
  		 * 
  		 * @return boolean
  		 */
  		showQuote: function(){
  			return (this.registration.quote_number != '' && this.step > 1 && this.registration.service == -1) || (this.quote_id_uncoded);
  		},
  		
  		clientNameLabel: function(){
  			return this.registration.client.businessClient ? 'Company Name' : 'Full Name';
  		},

  		showReseller: function(){
  			return store.state.reseller;
  		},

  		isBranchNumberDisabled: function(){
  			return this.registration.payment.bank_details.bankName != '' && this.registration.payment.bank_details.bankName.toLowerCase() != 'other';
  		},

  		isBusinessClient: function(){
  			return this.registration.client.businessClient == true;
  		},

  		showNumberRangeOption: function(){
  			return this.serviceSelection != "voipLineService";
  		},

  		limitAddToCart: function(){
  			return this.serviceSelection == "voipLineService" && this.cart.length > 0;
  		},

        requestHasHardware: function() {
            this.registration.client.hasHardware = (this.registration.hardware.length > 0 && this.registration.hardware[0].id != '') || store.state.hasQuoteHardware || this.registration.existingQuoteHasHardware;

            return this.registration.client.hasHardware;
        },

  		showPoa: function(){
  			return this.registration.payment.is_prepaid == true;
  		},

  		showPortingDocumentation: function(){
  			if(this.serviceSelection == 'transferServices' || this.serviceSelection == 'quoteWithTransfer'){
  				return false;
  			}
  			return this.registration.hasPort || (this.completingPorting && !this.registration.quote_number && !this.quote_id_uncoded);
  		},

  		showAbridgedForm: function(){
  			return this.registration.is_undecided === true;
  		},

  		/* Order confirmation page: a breakdown of once off fees */
  		totalOnceOffFees: function(){
  			if(this.serviceConfirmation.costs.hasOwnProperty('total_once_off') == false)
  			{
  				return '';
  			}

  			return this.serviceConfirmation.costs.total_once_off;
  		},

  		showNumbersOfDdis: function(){
  			if(this.serviceSelection == 'callDiversionService'){
  				return false;
  			}

  			return true;
  		},

  		showMonthlyUsage: function(){
  			if(this.serviceSelection == 'callDiversionService'){
  				return false;
  			}
  			
  			return true;
  		},

  		/* Validation */
  		isCurrentStepValid: function(){

  			var validation = false;

  			//Service selection
  			if(this.step == 1)
  			{
  			    validation = this.$v.registration.service.$error === false && this.$v.registration.quote_number.$error === false;
  			}

  			//Package selection
  			if(this.step == 2)
  			{
  				validation = this.$v.registration.package.$error === false;
  			}

  			//Number selection
  			if(this.step == 3)
  			{
  				validation = this.$v.registration.porting.$error === false && this.$v.validation.accountPaid.$error == false && this.$v.validation.numberLinkedToActiveService.$error == false && this.$v.singleTelephone.$error == false && this.$v.validation.areaConfirmation.$error == false;
  			}

			//Switchboard custom
  			if(this.step == 4)
  			{
  				validation = this.$v.registration.switchboard.$error === false;
  			}

  			//Trunk custom
  			if(this.step == 5)
  			{
  				validation = this.$v.registration.trunk.$error === false;
  			}

  			//Order confirmation
  			if(this.step == 7)
  			{
  				validation = this.$v.confirmation.$error === false;
  			}

  			//Client details
  			if(this.step == 8)
  			{
  				validation = this.$v.registration.client.$error === false && this.$v.signatory.$error == false;	

  			} //end step 8 validation

  			//Payment details
  			if(this.step == 9)
  			{
  				validation = this.$v.registration.payment.$error === false && this.$v.validation.postpaidMandate.$error == false && this.$v.validation.postpaidTnC.$error == false && this.$v.validation.prepaidTnC.$error == false;
  			} //end step 9

  			//Payment details
  			if(this.step == 10)
  			{
  				validation = this.$v.registration.documentation.$error === false;
  			} //end step 10

  			//Payment details
  			if(this.step == 12)
  			{
  				validation = this.$v.potential_client.$error === false;
  			} //end step 10

  			return validation;
  		},


  		/* End validation */

  		/**
  		 * Maximum number of steps: this will be used for the progress bar
  		 * 
  		 * @return int
  		 */
  		maxSteps: function(){

  			var max = 11; //By default

  			if(this.serviceSelection == 'voipLineService'){
				max = Object.keys(this.line_user_flow).pop(); 
			}

			if(this.serviceSelection == 'voipTrunkService'){
				max = Object.keys(this.trunk_user_flow).pop();
			}

			if(this.serviceSelection == 'vpbx'){
				max = Object.keys(this.vpbx_user_flow).pop();
			}

			if(this.serviceSelection == 'callDiversionService'){
				max = Object.keys(this.call_diversion_user_flow).pop();
			}

			if(this.serviceSelection == 'quote'){
				max = Object.keys(this.quote_user_flow).pop();
			}

			if(this.serviceSelection == 'linked_quote'){
				max = Object.keys(this.linked_quote_user_flow).pop();
			}

			if(this.serviceSelection == 'linkedQuoteWithPorting'){
				max = Object.keys(this.linked_quote_with_porting_flow).pop();
			}

			if(this.serviceSelection == 'transferServices'){
				max = Object.keys(this.transfer_services_flow).pop();
			}

			if(this.serviceSelection == 'quoteWithTransfer')
			{
				max = Object.keys(this.quote_with_tos_flow).pop();
			}

			return max;
  		},

  		/**
  		 * Controls the width of the progress bar based on the current step the user is at
  		 * 
  		 * @return string
  		 */
	    progressWith: function() 
	    {
	    	var counter = this.counter;
	    	var maxSteps = this.maxSteps;

	    	//Handle abridged form
	    	if(this.step == 12 || this.step == 13){
	    		counter = this.step; 
	    		maxSteps = 13;
	    	}

	      	return Math.round((counter / maxSteps) * 100) + "%";
	    },

	    completingPorting: function()
	    {
	    	var completingPortingForm = this.registration.porting.number_selection != null || this.registration.porting.individual_numbers.length != 0
			        || this.registration.porting.number_range_start != null || this.registration.portingnumber_range_end != null
			        || this.registration.porting.account_number != null || this.registration.porting.account_holder != null 
			        || this.registration.porting.is_prepaid != null || this.registration.porting.has_existing_service != null || 
			        this.registration.porting.retain_existing != null;
	    	
	    	//All the fields are empty:
    		//Check if the registration porting tab option has been selected:
    		if(this.activeNumberSelectionTab == 'porting' && this.completingNewNumber == false){
    			completingPortingForm = true;
    		}

			return completingPortingForm;

	    },

	    completingNewNumber: function()
	    {
			var numbers = this.registration.new_number;
			var completing = false;
			
			for(var i = 0; i < numbers.length; i++)
			{
				var number = numbers[i];

				for(const key in number){
	    			if (number.hasOwnProperty(key)) 
			     	{
			        	const element = number[key];

				        if (element !== "" && element !== null && element !== undefined && element !== false) 
				        {
				          	completing = true;
				          	break;
				        }
				    }
	    		}
			}

			//All the fields are empty:
    		//Check if the registration porting tab option has been selected:
    		if(this.activeNumberSelectionTab == 'new_number' && this.completingPorting == false){
    			completing = true;
    		}

			return completing;
	    },
		
		portingActiveTab: function(){
			return this.completingNewNumber == false;
		},

		newNumberActiveTab: function(){
	    	return this.completingNewNumber == true;
	    },
	    
		/**
	     * We keep track of whether or not the user is completing the postpaid tab
	     * @return boolean
	     */
	    completingPostpaid: function()
	    {
	        var details = this.registration.payment.bank_details;
			var completing = false;
			
			//We first check if any banking detail field on the postpaid form is filled
			for(const key in details){
    			if (details.hasOwnProperty(key)) 
		     	{
		        	const element = details[key];
					
			        if (element !== "" && element !== null && element !== undefined && element !== false) 
			        {
			          	completing = true;
			          	break;
			        }
			    }
    		}

    		//We check if the postpaid mandate checkbox is checked, or the postpaid terms and conditions
    		if((this.validation.postpaidMandate || this.validation.postpaidTnC) && !completing){
 				completing = true;
    		}

    		//If any of the fields are selected/filled on the postpaid form, we make sure we uncheck the checkbox on the prepaid tab
    		if(completing == true && (this.registration.payment.is_prepaid || this.validation.prepaidTnC))
        	{
        		this.registration.payment.is_prepaid = false;
        		this.validation.prepaidTnC = false;
        	}
		
    		//Check if the registration payment postpaid tab option has been selected:
    		//If the prepaid checkbox is not checked (meaning this.completingPrepaid is false) and the active tab is postpaid,
    		//we set completingPostpaid to true. This happens for instance when the page first loads
    		if(this.activePaymentTab == 'postpaid' && this.registration.payment.is_prepaid == false && this.validation.prepaidTnC == false && !completing){
    			completing = true;
    		}

			return completing;
	    },

	    /**
	     * We keep track of whether or not the user is completing the prepaid tab
	     * @return boolean
	     */
	    completingPrepaid: function(){
	    	var completing = (this.registration.payment.is_prepaid == true || this.validation.prepaidTnC == true) || (this.completingPostpaid == false && this.activePaymentTab == 'prepaid');
	    	
	    	return completing
	    },

	    postpaidActiveTab: function(){
			return this.completingPrepaid == false;
		},

		prepaidActiveTab: function(){
	    	return this.completingPrepaid == true;
	    },

	    /**
	     * Controls the current phone to display on the phone order page
	     * 
	     * @return object
	     */
	    currentPhone: function()
	    {
  			return this.phoneDisplay[Math.abs(this.currentIndex) % this.phoneDisplay.length];
  		},

  		/**
  		 * Determines the text to show on the 'next' button on the phone order page/
  		 * If there is no phone added on the cart, display 'Skip'
  		 * If the cart is not empty, display 'Next'
  		 * 
  		 * @return string
  		 */
  		phoneOrderAction: function() {
  			return this.cart.length == '' ? 'Skip' : 'Next';
  		},

  		individualNumberPlaceholder: function(){
  			return this.registration.porting.individual_numbers.length == 0 ? 'Enter a telephone number' : 'Add an additional number';
  		},

  		serviceDetails: function(){
  			var service = this.serviceConfirmation.services.hasOwnProperty('service') ? this.serviceConfirmation.services.service : '';

  			if(service.length == "")
  			{
  				return '';

  			}

  			if(Array.isArray(service))
  			{
  				return service.join("<br>");
  			}

  			return service;
  		},

  		serviceNumbers: function(){
  			var numbers = this.serviceConfirmation.services.hasOwnProperty('service_numbers') ? this.serviceConfirmation.services.service_numbers : '';

  			if(numbers.length == "")
  			{
  				return '';

  			}

  			if(Array.isArray(numbers))
  			{
  				return numbers.join("<br>");
  			}

  			return numbers;
  		},

  		/**
  		 * For hosted switchboard selection
  		 * 
  		 * @return string
  		 */
  		serviceAddons: function(){
  			var serviceAddons = this.serviceConfirmation.services.hasOwnProperty('service_addons') ? this.serviceConfirmation.services.service_addons : '';

  			if(serviceAddons.length == "")
  			{
  				return '';

  			}

  			if(Array.isArray(serviceAddons))
  			{
  				return serviceAddons.join("<br>");
  			}

  			return serviceAddons;
  		},

  		portNumberSelection: function()
  		{
  			var ports = this.serviceConfirmation.services.hasOwnProperty('port_number_selection') ? this.serviceConfirmation.services.port_number_selection : '';

  			if(ports.length == "")
  			{
  				return '';
  			}

  			if(Array.isArray(ports))
  			{
  				return ports.join("<br>");
  			}

  			return ports;
  		},
  		portDetails: function()
  		{
  			var details = this.serviceConfirmation.services.hasOwnProperty('port_details') ? this.serviceConfirmation.services.port_details : '';

  			if(details.length == "")
  			{
  				return '';
  			}

  			if(Array.isArray(details))
  			{
  				return details.join("<br>");
  			}

  			return details;
  		},
  		handsetDetails: function()
  		{
  			var handsets = this.serviceConfirmation.services.hasOwnProperty('handsets') ? this.serviceConfirmation.services.handsets : '';

  			if(handsets.length == "")
  			{
  				return '';
  			}

  			if(Array.isArray(handsets))
  			{
  				return handsets.join("<br>");
  			}

  			return handsets;
  		},
  		ricaDocument: function(){
  			return this.registration.documentation.rica.filename;
  		},
  		poaDocument: function(){
  			return this.registration.documentation.poa.filename;
  		},
  		portingDocument: function(){
  			return this.registration.documentation.porting.filename;
  		},

  		/* Validation error */
  		showAccountPaidFail: function(){
	    	return `	Unfortunately you will be unable to port if your current account isn't settled. If you would
					like to port, please settle your account and tick the confirmation box. Alternatively please click get
					a new number. If you get a new number now you can always port your number at a later stage.`;
	    },
	    showNumberLinkedToCancelled: function(){
	    	return `	Unfortunately we are unable to port numbers associated with cancelled services or in the
					process of being cancelled. To request a new number please click get a new number.`;
	    },
  	},

  	methods: {
  		/***********************************************************************
				When transmission account is selected, show warning text
  		***********************************************************************/
  		onAccountTypeSelection: function(){
  			if(this.registration.payment.bank_details.accountType == "TRANSMISSION" || this.registration.payment.bank_details.accountType == "SAVINGS") {
  				this.showTransmissionAccountWarning = true;

  				return;
  			}

  			this.showTransmissionAccountWarning = false;
  		},
  		/***********************************************************************
				When the page loads for the 1st time, fetch content
  		***********************************************************************/
  		fetchToken: function(){
  			var url = "/online-signup-service-api/v1/signup/token";
		    return this.$http.post(url, { page: 1 }).then(result => {
		      	var data = result.data;

		      	if (data.success) {
		        	store.state.token = data.data.token;
		        	return true;
		      	}

		      	return false;
	    	});
  		},

  		/***********************************************************************
				When the page loads for the 1st time, fetch content
  		***********************************************************************/
  		fetchContent: function(){
  			var url = "/online-signup-service-api/v1/signup/get-page";
	    	
	    	var dataToPost = {
	    		page: 1,
	    		token: store.state.token,
	    		reseller_id: this.reseller_id,
	    		quote_id: this.quote_id,
	    		referring_domain: this.referring_domain,
	    		tracking_cookie: this.tracking_cookie,
	    	}
	    	

		    this.$http.post(url, dataToPost).then(result => {
		    	                            
		    	                            
		    	this.loading = false; 
		      	var data = result.data;
		      	if (data.success) {
		      		if(data.data.show_invalid === true){
		      			this.$router.push('invalid') 

		      			return;
		      		}
					this.serviceList   = data.data.page_contents;
					this.requestId     = data.data.requestId;

					//store functions to set reseller options
					store.commit('setResellerOptions', data.data);
					
					if(data.data.quoteId)
					{
						this.quote_id_uncoded = data.data.quoteId;
						this.registration.hasPort = data.data.hasPort;

						this.handleQuote(data.data);
					}
					
					this.contentloaded = true;
		      	}
	    	});
  		},

		handleQuote: function(data){
            if(this.registration.hasPort)
            {
                this.serviceSelection = 'linkedQuoteWithPorting';
                //We will move to step 3
                this.step = 3;

	           	var codes = data.numberRanges;
	           	if(Object.keys(codes).length !== 0)
	           	{
	           		this.areaCodes = codes.hasOwnProperty('area_code') ? codes.area_code : null;
	           	}

                return;
           	}

           	if(!this.transfer_of_service){
               	this.serviceSelection = 'linked_quote';
               	//We will move to step 8
               	this.step = 8;
           	}
           	if(this.transfer_of_service){
               	this.serviceSelection = 'transferServices';
               	//We will move to step 14
               	this.step = 14;
           	}
   		},

  		/***********************************************************************
  										CAPTCHA
  		***********************************************************************/
  		

  		captchaHasError: function(data){
  			
  			var success = data.success;
  			var message = data.message;

  			if(!success){

  				message = data.errors.message;
				
				this.Swal.fire({
				  title: 'Please Note:',
				  html: message,
				  icon: 'error',
				  confirmButtonText: 'Okay'
				});

				//We allow them to click on next again for validation
		        this.isBtnLoading = false;

  				return;
  			}

  			this.submitCurrentStep()
			.then(function(data) 
			{
				this.moveToNextStep(data);

			}.bind(this));
  		},

  		contactHasError: function(){
			var error = false;

			if(!this.$refs.hasOwnProperty('additionalContacts') || this.$refs.additionalContacts.length == 0){
				return error;
			}
			for(var i = 0; i < this.$refs.additionalContacts.length; i++){
            	
                if (this.$refs.additionalContacts[i].$v.$invalid == true ) 
                {
                	error = true;
                	break;

                }
            }

            return error;
  		},

  		newNumberHasError: function(){
			var error = false;

			if(!this.$refs.hasOwnProperty('additionalNumbers') || this.$refs.additionalNumbers.length == 0){
				return error;
			}
			for(var i = 0; i < this.$refs.additionalNumbers.length; i++){
            	
                if (this.$refs.additionalNumbers[i].$v.$invalid == true ) 
                {
                	error = true;
                	break;

                }
            }

            return error;
  		},

  		/***********************************************************************
  									RESET METHODS
  		***********************************************************************/
  		
  		/**
  		 * Reset telephone entries on number selection -> Port my number -> Individual
  		 * 
  		 * @return void
  		 */
  		resetIndividualFields: function(){
  			this.telephone = '';
  			this.registration.porting.individual_numbers = [];
  		},

  		/**
  		 * Reset telephone entries on number selection -> Port my number -> Individual
  		 * 
  		 * @return void
  		 */
  		resetSingleNumberFields: function(){
  			if(this.singleTelephone != ''){
  				this.singleTelephone = '';
	  			this.registration.porting.individual_numbers = [];
  			}
  		},

  		/**
  		 * Reset telephone entries on number selection -> Port my number -> Range
  		 * 
  		 * @return void
  		 */
  		resetRangeFields: function(){
  			this.registration.porting.number_range_start = null;
  			this.registration.porting.number_range_end = null;
  		},

  		/**
  		 * Reset telephone entries on number selection -> Port my number
  		 * 
  		 * @return void
  		 */
  		resetPortingData: function(){
  			this.resetIndividualFields();
  			this.resetRangeFields();
  			this.resetSingleNumberFields();
  			
  			this.registration.porting.number_selection = null; //string for 'range' or 'individual'
			// this.registration.porting.is_sequential = false;
			this.registration.porting.account_number = null;
			this.registration.porting.account_holder = null;
			this.registration.porting.is_prepaid = null;
			this.registration.porting.has_existing_service = null;
			this.registration.porting.retain_existing = null;

			//clear the checboxes
			this.validation.accountPaid = false;
			this.validation.numberLinkedToActiveService = false;
  		},

  		/**
  		 * Reset telephone entries on number selection -> Get a new number
  		 * 
  		 * @return void
  		 */
  		resetNewNumberData: function(){
  			this.registration.new_number = [
  				{
  					area_code: "",
			        //is_sequential = false;
			        number_selection : null, //string for 'range' or 'individual'
			        number_range : null,
			        areaConfirmation : false
  				}
  			];

  			//clear the checkox
  			this.validation.areaConfirmation = false;
  		},

  		/**
  		 * File select
  		 * @param  {[type]} event   [description]
  		 * @param  {[type]} element [description]
  		 * @return {[type]}         [description]
  		 */
  		fileSelect: function(event, element){
	
			var file = '';
			var filename = '';

			if(event.target.files.length != 0)
			{
				file = event.target.files[0];
				filename = file.name;
			}

			if(element == 'rica')
			{
				this.registration.documentation.rica.document = file;
				this.registration.documentation.rica.filename = filename;
			}

			if(element == 'poa')
			{
				this.registration.documentation.poa.document = file;
				this.registration.documentation.poa.filename = filename;
			}

			if(element == 'porting')
			{
				this.registration.documentation.porting.document = file;
				this.registration.documentation.porting.filename = filename;
			}
  			this.inputName = filename;
  		},

   
  		/***********************************************************************
  									BLUR METHODS
  		***********************************************************************/
  		
  		/**
  		 * On number selection, port my number, if you select individual number,
  		 * Once a telephone number is filled in, a new box opens, either on blur or when clicking the + button
  		 */
  		addIndividualNumbers: function(){

  			if(this.telephone == ''){
  				return;
  			}

  			this.registration.porting.individual_numbers.push(this.telephone);
  			this.telephone = "";
  		},

  		addSingleTelephone: function(){

  			if(this.singleTelephone == ''){
  				return;
  			}

  			this.registration.porting.individual_numbers = [];
  			this.registration.porting.individual_numbers.push(this.singleTelephone);
  			this.registration.porting.number_selection = 'individual';
  		},

  		/**
  		 * Validate number of channels based on number selection
  		 */
  		validateChannels: function(){

  			var minChannels = 4;
  			if(this.registration.trunk.channels < minChannels || isNaN(this.registration.trunk.channels)){

  				var message ='You can choose from a minimum of 4 channels on a VoIP Trunk.';

  				this.Swal.fire({
						  title: 'Please Note:',
						  html: message,
						  icon: 'info',
						  confirmButtonText: 'Okay'
						});

  				this.registration.trunk.channels = minChannels;
  			}
  		},

  		/**
         * Validate number of channels based on number selection
         */
        validateExtensions: function(){
            if(!this.isValidRange(this.registration.switchboard.extensions)){

                var message = 'Extensions must be selected in multiples of 10.';

                this.Swal.fire({
                          title: 'Please Note:',
                          html: message,
                          icon: 'info',
                          confirmButtonText: 'Okay'
                        });

                this.registration.switchboard.extensions = this.roundUpRange(this.registration.switchboard.extensions);
            }
        },
        
        /**
         * Valid extensions ranges must be multiple of ten
         * @return boolean
         */
        isValidRange: function(value){
        	if(isNaN(value)){return false;}
            return value % 10 == 0;
        },

        roundUpRange: function(value){
        	var minExtensions = 10;
        	if(isNaN(value)){return minExtensions;}

            return Math.ceil(value / 10) * 10;
        },

  		/***********************************************************************
  									REGULAR METHODS
  		***********************************************************************/

        getPackageName: function(option){
        	if(!option.description){
        		return option.name;
        	}

        	return `${option.name} (${option.description})`;
        },

  		/**
  		 * Determines whether or not to show the "Previous" button 
  		 */
  		prevStepFromClientDetails: function()
  		{
  			if(this.transfer_of_service || this.serviceSelection == 'quoteWithTransfer')
  			{
  				return true;
  			}

  			if(this.quote_id_uncoded && this.registration.hasPort == false)
  			{
  				return false;
  			}

  			return true;
  		},

		/**
  		 * Update service fees summary
  		 */
  		getServiceFees(service)
        {
            var fees = "From " + service.service_fees + " per month";
            if(service.alias == 'vpbx')
            {
                fees += " + (VoIP Trunk - From R100.00 (R86.96 + VAT ) for 4 channels) per month";
            }
            
            return fees;
        },
		
  		/**
  		 * On number selection, port my number, if you select indicidual number,
  		 * 
  		 * @param  int key The position of the number in the array
  		 * @return void
  		 */
  		removeIndividualNumber: function(key){
  			this.registration.porting.individual_numbers.splice(key, 1);
  		},

		foundInBundle: function(phone){
  			
  			if(this.bundleOptions.length == 0){
  				return false;
  			}

      		var result = false;
      		var optionsArrays = [];

      		for(i = 0; i < this.bundleOptions.length; i++){
      			if(this.bundleOptions[i].options && Array.isArray(this.bundleOptions[i].options)){
      				optionsArrays.push(this.bundleOptions[i].options);
      			}	
      		}

      		var options = Array.prototype.concat.apply([], optionsArrays);
      		
      		for(var i = 0; i < options.length; i++){
      			if(options[i].id == phone.id){
      				result = true;
      				break;
      			}
      		}

      		return result;
  		},

	    addPhoneToCart: function(index, phoneId = '') {
	    	
	      	var item = null;

	      	if(index > -1){
	      		item = this.phoneDisplay[index];
	      	}

	      	if(!item && phoneId != '')
	      	{
	      		item = this.findPhone(phoneId);
	      	}	

	      	var existing = this.phoneOrders.indexOf(item);

	      	if(existing > -1){
	      		this.phoneOrders[existing].quantity++;
	      	}else{
	      		//item.quantity = 1; //this will not make the item reactive
	      		this.$set(item, 'quantity', 1)
	      		this.phoneOrders.push(item);
	      	}

	      	var dataToPost = {
	      		hardware: this.phoneOrders,
	      		token: store.state.token
	      	};

	      	var url = "";
      		url = "/online-signup-service-api/v1/signup/hardware/total-cost";
      		this.$http.post(url, dataToPost).then(result => {
	    		var data = result.data;

	        	if (data.success) {
					this.cart          = data.data.unit_costs;
					this.cartTotals    = data.data.cart_totals;
					this.bundleOptions = data.data.required_bundle_options;

					var message = item.name + ' has been added to the cart';
					this.Swal.fire({
						title: 'Cart updated',
					  	html:  message,
					  	icon: 'success',
					  	timer: 2000,
					  	showConfirmButton: false,
					});
	        	}

	        	//set the hardware property on our main object
      			this.registration.hardware = this.phoneOrders;
      		});
	    },

	    removePhoneFromCart: function(index, phoneId = ''){
	    	var item = null;

	      	if(index > -1){
	      		item = this.phoneDisplay[index];
	      	}

	      	if(!item && phoneId != '')
	      	{
	      		item = this.findPhone(phoneId);
	      	}	

	      	var existing = this.phoneOrders.indexOf(item);

	      	if(existing > -1){
	      		this.phoneOrders[existing].quantity--;
	      	}

	      	if (this.phoneOrders[existing].quantity < 1 ) {
	        	this.phoneOrders.splice(existing, 1);
	      	}

	      	var dataToPost = {
	      		hardware: this.phoneOrders,
	      		token: store.state.token
	      	};

	      	var url = "";
      		url = "/online-signup-service-api/v1/signup/hardware/total-cost";
      		this.$http.post(url, dataToPost).then(result => {
	    		var data = result.data;


	        	if (data.success) {
					this.cart          = data.data.unit_costs;
					this.cartTotals    = data.data.cart_totals;
					this.bundleOptions = data.data.required_bundle_options;
	        	}

	        	//set the hardware property on our main object
      			this.registration.hardware = this.phoneOrders;
      		});
	    },
	   
	    /**
	     * Delete selected phone from cart
	     * 
	     * @param  Object item 
	     * @return void
	     */
	    deletePhoneFromCart: function(item) {
	      	
	      	var selectedIndex = this.phoneOrders.findIndex(function(element){
	      		return element.id == item.id;
	      	});

	      	if (selectedIndex > -1) {
	        	this.phoneOrders.splice(selectedIndex, 1);
	      	}

	      	var dataToPost = {
	      		hardware: this.phoneOrders,
	      		token: store.state.token
	      	};

      		var url = "/online-signup-service-api/v1/signup/hardware/total-cost";
      		this.$http.post(url, dataToPost).then(result => {
	    		var data = result.data;

	        	if (data.success) {
	          		this.phoneOrders = this.cart = data.data.unit_costs;
	          		this.cartTotals = data.data.cart_totals;
	          		this.bundleOptions = data.data.required_bundle_options;
	        	}

	        	//set the hardware property on our main object
      			this.registration.hardware = this.phoneOrders;
      		});
	    },

	    /**
	     * Empty the current cart
	     * 
	     * @return void
	     */
   	 	emptyCart: function() {
      		this.cart = [];
      		this.phoneOrders = [];
      		this.cartTotals = [];

      		//set the hardware property on our main object
      		this.registration.hardware = this.phoneOrders;
      		this.bundleOptions = [];
    	},

	    filterItems: function(item) {

	    	this.activeFilter = item;

	    	this.currentIndex = 0;

	    	if(item == 'all')
	    	{
	    		this.getAllPhones();
	    		return;
	    	}
	      	this.phoneDisplay = this.phoneList[item];
	      	
	    },
	    getAllPhones: function(){
	    	var phones = [];
	    	for (var prop in this.phoneList) {
	          	if (Object.prototype.hasOwnProperty.call(this.phoneList, prop)) {
	            	var phonesInCategory = this.phoneList[prop];
		            for(var i = 0; i < phonesInCategory.length; i++)
		            {
		                phones.push(phonesInCategory[i]);
		            }
	          	}
	        }
	        
			this.allPhones    = phones;
			this.phoneDisplay = phones;
	    },


	    getPhoneName: function(id)
	    {
	    	var phone = this.findPhone(id);
	    	return phone.name;
	    },

	    findPhone: function(id)
	    {
	    	var phoneIndex = this.allPhones.findIndex(function(element){
	      		return element.id == id;
	      	});
	     
	    	var phone = this.allPhones[phoneIndex];

	      	return phone;
	    },

	    setService: function(selection) {
	      	this.serviceSelection = selection;

	      	if(selection != 'quote' && !this.registration.quote_number ){
	      		this.registration.quote_number = null;
	      	}
	    },
	  
	    addNewNumber: function(){
	    	
            var tempNumber = {
                	area_code: "",
                    is_sequential: false,
                    number_selection: null, //string for 'range' or 'individual'
                    number_range: null,
                };
            this.numbers.push(tempNumber);
            this.registration.new_number.push(tempNumber);

        },
        deleteNumber: function(position){
        	this.numbers.splice(position, 1);
        	this.registration.new_number.splice(position, 1);
        },
        hideHardwareDeliveryInput: function(){
            this.showHardwareDeliveryAddress            = false;
            this.registration.client.useHardwareAdrress = false;
        },
		showHardwareDeliveryInput: function(){
            this.showHardwareDeliveryAddress            = true;
            this.registration.client.useHardwareAdrress = true;
		},
        showContactForm: function(){
        	// if(this.registration.users.length != 0){
        	// 	return;
        	// }
        	if(this.contacts.length != 0){
        		return;
        	}

        	this.addContact();
        },
	    addContact: function() {

	    	this.hasAdditional = true;

	    	var newContact = {
	    		id: this.getNextContact(),
	    		idNumber: '',
	    		fullName: '',
	    		email: '',
	    		telephone: '',
	    		mobile: '',
	    		type: '',
	    		sendBilling: false,
			    sendTechnical: false,
			    sendOrdering: false,
			    sendMarketing: false,
			    signatory: false
	    	}

	      	this.contacts.push(newContact);
	      	// this.registration.users.push(newContact);

	    },

	    getNextContact: function(){
	    	var next = 1;

	    	if(this.contacts.length != 0){

	    		var maxContact = this.contacts.reduce(function(prev, current) {

				    if (current.id > prev.id) {
				    	
				        return current;
				    } else {
				        return prev;
				    }
				});

				
				var max = maxContact.id;
				next = max + 1;
	    	}

	    	return next; 	
	    },

	    deleteContact: function(position) {
	      	this.contacts.splice(position, 1);

	      	if(this.contacts.length == 0){
	      		this.hasAdditional = false;
	      	}
	    },
	    hideContact: function() {
	    	this.hasAdditional = false;
	      	this.contacts = [];
	    },

	    prev: function(){
	    	this.currentIndex -= 1;
	    },
	    next: function(){
	    	this.currentIndex += 1;
	    },
    	prevStep: function() {
	      	if (this.step == 1) {
	        	this.step = 1;
	        	return;
	      	}

            this.counter--;
			if(this.serviceSelection == 'voipLineService'){
				this.step = this.line_user_flow[this.counter];
			}

			if(this.serviceSelection == 'voipTrunkService'){
				this.step = this.trunk_user_flow[this.counter];
			}

			if(this.serviceSelection == 'vpbx'){
				this.step = this.vpbx_user_flow[this.counter];
			}

			if(this.serviceSelection == 'callDiversionService'){
				this.step = this.call_diversion_user_flow[this.counter];
			}

			if(this.serviceSelection == 'quote'){
				this.step = this.quote_user_flow[this.counter];
			}

			if(this.serviceSelection == 'linked_quote'){
				this.step = this.linked_quote_user_flow[this.counter];
			}

			if(this.serviceSelection == 'linkedQuoteWithPorting'){
                this.step = this.linked_quote_with_porting_flow[this.counter];
            }

			if(this.serviceSelection == 'transferServices'){
				this.step = this.transfer_services_flow[this.counter];
			}

			if(this.serviceSelection == 'quoteWithTransfer'){
				this.step = this.quote_with_tos_flow[this.counter];
			}

			if(this.matrix[this.step] == 4 && !store.state.canOrderHardware){
				//we skip this step, we do not show the hardware page
				this.prevStep();
			}

      		if(this.step == 8)
      		{
      			//we remove signatory from users array
      			
      			this.registration.users.shift();
      		}

      		//We make sure the window scrolls to top
            scrollTop();
	    },

    	nextStep: function() {
    		
      		this.isBtnLoading = true;

    		//When the users clicks 'Next' We trigger the validation plugin'
    		
    		//Service selection
    		if(this.step == 1){
    			this.$v.registration.service.$touch();
    			this.$v.registration.quote_number.$touch();
    			
	    		if (this.$v.registration.service.$invalid || this.$v.registration.quote_number.$invalid) {
			        this.isBtnLoading = false;
			        scrollToError('alert');
			    	return;
			    }

			    //We will trigger the recaptcha validation on the component
			   	this.validateCaptcha++;
    		}

    		//Package
    		if(this.step == 2){
    			this.$v.registration.package.$touch();
	    		if (this.$v.registration.package.$invalid) {
			        this.isBtnLoading = false;
			        scrollToError('alert');
			    	return;
			    }
    		}

    		//Number selection
            if(this.step == 3)
            {
	        	this.$v.registration.porting.$touch();
	        	this.$v.singleTelephone.$touch();
	        	this.$v.telephone.$touch();
	        	//The checkboxes under number porting
	        	this.$v.validation.accountPaid.$touch();
	        	this.$v.validation.numberLinkedToActiveService.$touch();
      			//The checkboxes under new number
      			this.$v.validation.areaConfirmation.$touch();
      			// this.$v.registration.new_number.$touch();

      			//Validate new number component
      			this.validateNewNumber++;

	        	if(this.$v.registration.porting.$invalid)
	        	{
	        		this.isBtnLoading = false;
	        		scrollToError('form-group');

	        		return;
	        	}

	        	if(this.$v.singleTelephone.$invalid || this.$v.telephone.$invalid)
	        	{
	        		this.isBtnLoading = false;
	        		scrollToError('form-group');
	        		return;
	        	}

	        	if(this.newNumberHasError())
	        	{
	        		this.isBtnLoading = false;
	        		scrollToError('form-group');
	        		return;
	        	}

	        	if(this.$v.validation.accountPaid.$invalid || this.$v.validation.numberLinkedToActiveService.$invalid || this.$v.validation.areaConfirmation.$invalid )
	        	{
	        		this.isBtnLoading = false;
	        		scrollToError('form-group');
	        		return;
	        	}
            }

            //Switchboard custom
    		if(this.step == 4){
    			this.$v.registration.switchboard.$touch();
	    		if (this.$v.registration.switchboard.$invalid) {
			        this.isBtnLoading = false;
			        scrollToError('form-group');
			    	return;
			    }
    		}

    		//Trunk custom
    		if(this.step == 5){
    			this.$v.registration.trunk.$touch();
	    		if (this.$v.registration.trunk.$invalid) {
			        this.isBtnLoading = false;
			    	scrollToError('form-group');
			    	return;
			    }
    		}

    		//Order confirmation
    		if(this.step == 7){
    			this.$v.confirmation.$touch();
	    		if (this.$v.confirmation.$invalid) {
			        this.isBtnLoading = false;
			        scrollToError('alert');
			    	return;
			    }
    		}

    		//Client
    		if(this.step == 8){
    			this.$v.registration.client.$touch();
    			// this.$v.registration.users.$touch();
    			this.$v.signatory.$touch();
    			
    			//We trigger additional contacts validation
    			this.validateContact++;

	    		if (this.$v.registration.client.$error || this.$v.signatory.$error || this.contactHasError()) {
			        this.isBtnLoading = false;
			        scrollToError('form-group');
			    	return;
			    }
	           
    		}

    		if(this.step == 9){
    			this.$v.registration.payment.$touch();
    			this.$v.validation.postpaidMandate.$touch();
    			this.$v.validation.postpaidTnC.$touch();
    			this.$v.validation.prepaidTnC.$touch();
    			 
	    		if (this.$v.registration.payment.$invalid || this.$v.validation.postpaidMandate.$invalid || this.$v.validation.postpaidTnC.$invalid || this.$v.validation.prepaidTnC.$invalid) {
			    	this.isBtnLoading = false;
			    	scrollToError('form-group');
			    	return;
			    }
			 
    		}

    		if(this.step == 10){
    			this.$v.registration.documentation.$touch();
    			
	    		if (this.$v.registration.documentation.$invalid) {
	    			this.isBtnLoading = false;
	    			scrollToError('form-group');
			    	return;
			    }
    		}

    		if(this.step == 12){
    			this.$v.potential_client.$touch();

    			if (this.$v.potential_client.$invalid) {
	    			this.isBtnLoading = false;
	    			scrollToError('form-group');
			    	return;
			    }
    		}
    		
    		if(this.step == 14){
    			//Nothing. Validation is done in the component
    		}

    		if(this.step != 1){
    			//Submit current page
	    		this.submitCurrentStep()
	    			.then(function(data) 
	    			{
	    				this.moveToNextStep(data);

	    			}.bind(this));
    		}
		},

		showErrors: function(data){
			this.errors = 'An error has occured. Please try again.';

			if(!data.success && data.hasOwnProperty('errors')){
				if(data.errors.hasOwnProperty('messages')){
					this.errors = data.errors.messages.join('<br>');	
				}
				if(data.errors.hasOwnProperty('message')){
					this.errors = data.errors.message;	
				}
			}
			
			this.Swal.fire({
			  title: 'Please Note:',
			  html: this.errors,
			  icon: 'error',
			  confirmButtonText: 'Okay'
			});
		},

		submitCurrentStep: function(){

			//we are gonna submit current page information
      		var submitUrl = "/online-signup-service-api/v1/signup/submit-page";


      		if(this.matrix.hasOwnProperty(this.step) == false){
      			var data = {
	                            'success': false,
	                            'errors': {
	                                'message' : 'Unable to find requested step. Please try again later.'
	                            }
	                        };

      			this.showErrors(data);
      			return;
      		}

      		if(this.step == 3){
      			//We just ensure number_selection string is accurate
      			if(this.registration.porting.individual_numbers.length != 0){
      				this.registration.porting.number_selection = 'individual';
      			}
      			if(this.registration.porting.number_range_start & this.registration.porting.number_range_end){
      				this.registration.porting.number_selection = 'range';
      			}
      		}

      		//When the order confirmation page has been submitted
      		if(this.step == 7){
      			this.orderConfirmed = true;
      		}else{
      			this.orderConfirmed = false;
      		}

      		if(this.step == 8)
      		{
      			//Let's push the signatory to the users array if there isn't one already
      			this.registration.users = this.contacts;
      			this.registration.users = this.registration.users.filter(function(user){
      				return user.signatory != true;
      			});

      			this.registration.users.unshift(this.signatory);
      		}

      		var pageUrl = this.matrix[this.step];

      		var submitPagePost = {
      			page: pageUrl, 
      			payload: this.registration,
      			requestId: this.requestId,
      			token: store.state.token
      		};

      		if(this.step == 12){
      			//We add the potential_client detail
      			submitPagePost.payload = {};
      			submitPagePost.payload.potential_client = this.potential_client;
      		}

      		//Transfer of service page
      		if(this.step == 14){
      			//We add the potential_client detail
      			submitPagePost.serviceTransfer = this.serviceTransfer;
      		}

      		//Let's check if a quote number was entered
      		if(this.step == 1 && this.registration.quote_number && this.registration.service == -1){
      			submitUrl = '/online-signup-service-api/v1/signup/existing-quote';

      			submitPagePost = {
					      			page: pageUrl, 
					      			requestId: this.requestId,
					      			token: store.state.token,
					      			quoteId: this.registration.quote_number
					      		};

      			return this.$http.post(submitUrl, submitPagePost).
      				then(result => {
		      			var data = result.data;

		      			if(data.success && data.data){
							var content                                = data.data;
							this.registration.hasPort                  = content.hasOwnProperty('hasPort') ? content.hasPort : false;
							this.registration.existingQuoteHasHardware = content.hasOwnProperty('hasQuoteHardware') ? content.hasQuoteHardware : false;
							var hasTransferOfService                   = content.hasOwnProperty('hasTransferOfServices') ? content.hasTransferOfServices : false;
							
							if(hasTransferOfService)
							{
								this.serviceSelection = 'quoteWithTransfer';
							}
							
		      			}

		      			return data;
		      		}).catch(function(data){
		      			return error.response.data;
	  				}.bind(this));
      		}

      		//The client selected transfer on services, on step 1
      		if(this.step == 1 && this.registration.service == -2){
      			submitUrl = '/online-signup-service-api/v1/signup/service-transfer-selection';
      		}

      		if(this.step != 10)
      		{
      			return this.$http.post(submitUrl, submitPagePost).
      				then(result => {
		      			var data = result.data;

		      			if(data.success && data.data){
		      				var content = data.data;
		      				if(this.step == 1 && content.hasOwnProperty('hasPort')){
		      					this.registration.hasPort = content.hasPort;
		      				}
		      				if(this.step == 12 && content.hasOwnProperty('rt_ticket')){
		      					store.commit('setRtTicketNumber', content.rt_ticket);
		      				}
	    				}

		      			return data;
		      		}).catch(function(error){
		      			return error.response.data;
	  				}.bind(this));
      		}

      		if(this.step == 10)
      		{
	      		var formData = new FormData();
	      		formData.append('page', pageUrl);
	  			formData.append('documentation', JSON.stringify(this.registration.documentation));
                formData.append('rica', this.registration.documentation.rica.document);
                formData.append('porting', this.registration.documentation.porting.document);
                formData.append('poa', this.registration.documentation.poa.document);
                formData.append('requestId', this.requestId);
                formData.append('token', store.state.token);
                
                return this.$http.post("/online-signup-service-api/v1/signup/submit-document", 
	  				formData,
	  				{	
	  					headers: 
	  					{
	  						'Content-Type' : 'multipart/form-data'
	  					}
	  				}).then(function(result){
	  					var data = result.data;
	  					return data;
	  				}).catch(function(error){
	  					return error.response.data;
	  				}.bind(this));
      		}

		},

		moveToNextStep: function(data){

			this.isBtnLoading = false;

			if(data && !data.success)
			{	
				this.showErrors(data);

				//We do not move to the next step;
				return;
			}

			//This manages the matrix linked to the API
			this.step++;

			//This will help determine the step based on service selection and flow
			this.counter++;

			//Get next step based on counter
			this.getNextStep();
			
	      	//Will populate the data
	      	this.handleStep();
		},

		getNextStep: function(){

			//We handle the abridged form flow 
			if(this.showAbridgedForm == true && this.orderConfirmed){
				this.step = 12;
				return;
			}

			if(this.step == 13){
				//we will just show the thank you page
				return;
			}

			//We handle the normal user flow for voip line, voip trunk, vpbx and quote
			if(this.serviceSelection == 'voipLineService'){
				this.step = this.line_user_flow[this.counter];
			}

			if(this.serviceSelection == 'voipTrunkService'){
				this.step = this.trunk_user_flow[this.counter];
			}

			if(this.serviceSelection == 'vpbx'){
				this.step = this.vpbx_user_flow[this.counter];
			}

			if(this.serviceSelection == 'callDiversionService'){
				this.step = this.call_diversion_user_flow[this.counter];
			}

			if(this.serviceSelection == 'quote'){
				this.step = this.quote_user_flow[this.counter];
			}

			if(this.serviceSelection == 'linked_quote'){
				this.step = this.linked_quote_user_flow[this.counter];
			}
			
			if(this.serviceSelection == 'linkedQuoteWithPorting'){
                this.step = this.linked_quote_with_porting_flow[this.counter];
            }

			if(this.serviceSelection == 'transferServices'){
				this.step = this.transfer_services_flow[this.counter];
			}

			if(this.serviceSelection == 'quoteWithTransfer')
			{
				this.step = this.quote_with_tos_flow[this.counter];
			}
		},

    	handleStep: function() {

      		if (this.matrix.hasOwnProperty(this.step) == false) {
      			var data = {
	                            'success': false,
	                            'errors': {
	                                'message' : 'Unable to find requested step. Please try again later.'
	                            }
	                        }; 

      			this.showErrors(data);
        		return;
      		}

      		//If this step is thephone order page, and we cannot order hardware we skip it
      		if(this.matrix[this.step] == 4 && !store.state.canOrderHardware){
				//we skip this step, we do not show the hardware page
				this.moveToNextStep();
				return;
			}

      		//We fetch content for the next page
	      	var pageUrl = this.matrix[this.step];
	      	var url = "";
      		url = "/online-signup-service-api/v1/signup/get-page";

      		var dataToPost = {
				page:pageUrl,
				token: store.state.token,
				requestId: this.requestId, //needed for step 5 (custom trunk), step 7 (order confirmation)
      		};

      		if(this.step == 2){
      			dataToPost.service = this.registration.service;
      		}

      		//Let's send the request
      		this.$http.post(url, dataToPost).then(result => {
	    		var data = result.data;
	        
	        	if (data.success) {
	          		//Service selection
		          	if (this.step == 1) {
			            this.serviceList = data.data.page_contents;
			            this.requestId = data.requestId;
		          	}

	          		//Package selection
	          		if (this.step == 2) {
			            this.packageOptions = data.data.page_contents.packages;
	          		}

	          		//Number selection ('port my number' and 'get a new number')
	          		if (this.step == 3) {
	            		this.areaCodes = data.data.page_contents.area_code;
	          		}

	          		//switchboard customization == api page 8
	          		if (
			            this.step === 4 &&
			            this.serviceSelection == "vpbx"
	          		) {
			            this.baseExtension = data.data.page_contents.extensions;
			            this.callRecordingList =
			              data.data.page_contents.call_recording_options;
			            this.voiceProList = data.data.page_contents.voice_pro_options;
	          		}

	          		if(this.step == 5)
	          		{
		      			this.isUnlimitedPackage = data.data.page_contents.hasOwnProperty('package') && data.data.page_contents.package !== null ? data.data.page_contents.package.is_unlimited : false;
		      			if(!this.isUnlimitedPackage){
 				  			this.registration.trunk.channels = data.data.page_contents.suggested_channel_count;
		      			}else{
		      				this.registration.trunk.channels = '';
		      			}
	          			this.ddiNumbers = data.data.page_contents.hasOwnProperty('ddi_count') ? data.data.page_contents.ddi_count : 0;
	          			this.extensions = data.data.page_contents.hasOwnProperty('extensions') ? data.data.page_contents.extensions : 0;
	          		}

	          		//Hardware selection == api page = 4
		          	if (this.step == 6) {
		            	this.phoneList = data.data.page_contents.device_categories;
		            	this.getAllPhones(); //We will show all phones by default
		          	}

		          	//Service selection == api page = 5
		          	if(this.step == 7)
		          	{
		          		this.serviceConfirmation.services = data.data.page_contents.service_details;
		          		this.serviceConfirmation.costs = data.data.page_contents.costs;
		          	}

	          		//Payment details == api page = 7
	          		if (this.step == 9) {
	            		this.bankList = data.data.page_contents.banks;
	            		this.accountTypes = data.data.page_contents.account_types;
	          		}

	        	}
      		});

      		//We make sure the window scrolls to top
            scrollTop()
    	},
  	}
};
</script>
